import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { useForm, useFieldArray, useWatch } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import axios from "axios";
// import { toast } from "react-hot-toast";
import { toast, ToastContainer } from "react-toastify";
import Select from "react-select/async";
import { format, differenceInCalendarDays, parseISO } from "date-fns";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHospital,
  faCalendar,
  faBed,
  faStethoscope,
  faUserMd,
  faFileMedical,
  faPlus,
  faTrash,
  faUpload,
  faCheck,
  faSpinner,
  faExclamationTriangle,
  faShieldAlt,
  faFileInvoice,
  faClock,
  faInfoCircle,
  faRefresh,
  faDownload,
  faTimes,
  faGear,
  faEye,
  faFilter,
  faMoneyBillWave,
  faBrain,
  faFileCircleCheck,
  faUser,
  faRobot,
  faWindowMaximize,
  faWindowRestore,
  faWindowMinimize,
} from "@fortawesome/free-solid-svg-icons";
import { BASE_URL } from "../../config";
import { motion, AnimatePresence } from "framer-motion";
import LoadingScreen from "../../components/LoadingScreen";
import AiIcdChat from "../../components/AiIcdChat";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);
const RNB_DAYS_MISMATCH_TOAST_ID = "rnb-days-mismatch-toast";
const RNB_DAYS_MISMATCH_MESSAGE =
  "No. of Days confined does not match total Room & Board Days Confined!";
const ENABLE_AI_ICD_SEARCH = false;
const getCurrentDateTimeLocal = () => format(new Date(), "yyyy-MM-dd'T'HH:mm:ss");

const schema = yup.object({
  admission_date: yup.string().required("Admission date is required"),

  discharged_date: yup
    .string()
    .required("Discharge date is required")
    .test(
      "after-admission",
      "Discharge must be after admission",
      function (value) {
        const ad = this.parent.admission_date;
        return (
          !ad ||
          !value ||
          differenceInCalendarDays(parseISO(value), parseISO(ad)) >= 0
        );
      }
    ),

  // // ✔ You ONLY have a datetime-local, so this is the ONLY required field
  soa_received_date: yup.string().required("SOA received date is required"),

  // // ❌ Removed because NOT present in the UI
  // // soa_received_time_h
  // // soa_received_time_m
  // // soa_received_time_a

  initial_diagnosis: yup.string().required("Initial diagnosis is required"),

  final_diagnosis: yup.string().required("Final diagnosis is required"),

  // rnb_rows: yup
  //   .array()
  //   .of(
  //     yup.object({
  //       room_type: yup.string().required("Room type is required"),
  //       room_no: yup.string().required("Room number is required"),
  //       rate: yup.number().min(0).required("Rate is required"),
  //       days: yup.number().min(1).required("Days confined is required"),
  //       amount: yup.number().min(0),
  //       covered: yup.number().min(0),
  //     })
  //   )
  //   .min(1, "At least one R&B entry is required")
  //   .test(
  //     "days-match",
  //     "No. of Days confined does not match total Room & Board Days Confined!",
  //     function (value) {
  //       const totalDays = value.reduce((sum, row) => sum + (row.days || 0), 0);
  //       const formDays =
  //         differenceInDays(
  //           parseISO(this.parent.discharged_date),
  //           parseISO(this.parent.admission_date)
  //         ) + 1;
  //       return totalDays === formDays;
  //     }
  //   ),

  // surgical_rows: yup.array().of(
  //   yup.object({
  //     ruv_description: yup.string().required("RUV Description is required"),
  //     remarks: yup.string(),
  //     rnb_type: yup.string(),
  //     ruv_unit: yup.number().min(0),
  //     amount: yup.number().min(0).required("Amount is required"),
  //     philhealth: yup.number().min(0).default(0),
  //     operating_room_amount: yup.number().min(0).default(0),
  //   })
  // ),

  // misc_rows: yup.array().of(
  //   yup.object({
  //     particulars: yup.string().required("Particulars is required"),
  //     amount: yup.number().min(0).required("Amount is required"),
  //   })
  // ),

  // misc_rows_philhealth: yup.number().min(0),

  // physician_rows: yup
  //   .array()
  //   .of(
  //     yup.object({
  //       physician: yup.string().required("Physician is required"),
  //       role: yup.string().required("Role is required"),
  //       amount: yup.number().min(0).required("Amount is required"),
  //       philhealth: yup.number().min(0).default(0),
  //     })
  //   )
  //   .min(1, "At least one physician is required"),

  // corporate_guarantee: yup.boolean(),
  // provider_guarantee: yup.boolean(),

  // guaranteed_amount: yup.number().min(0).when("corporate_guarantee", {
  //   is: true,
  //   then: (s) => s.required("Guaranteed amount is required"),
  // }),

  // corp_approved_by: yup.string().when("corporate_guarantee", {
  //   is: true,
  //   then: (s) => s.required("Corporate approver is required"),
  // }),

  // amap_approved_by: yup.string().when("provider_guarantee", {
  //   is: true,
  //   then: (s) => s.required("AMAP approver is required"),
  // }),

  // // ✔ Only required IF corporate_guarantee = true
  // proof_guarantee_upload: yup.string().when("corporate_guarantee", {
  //   is: true,
  //   then: (s) => s.required("Proof of guarantee files are required"),
  // }),

  // // ✔ Always required by your UI
  // // soa_fileupload: yup.string().required("SOA files are required"),

  // ph_file: yup.boolean(),
  // ph_comp: yup.boolean(),

  // remarks: yup.string(),
  // claim_remarks: yup.string(),

  // uncovered_amount: yup.number().min(0),
  // member_share_amount: yup.number().min(0),

  // 👇 the hidden control field
  is_delay: yup.boolean().default(false),

  // ========== DELAY FIELDS ==========
  delay_responsible: yup.string().when("is_delay", {
    is: true,
    then: (s) => s.required("Responsible for delay is required"),
    otherwise: (s) => s.notRequired(),
  }),

  delay_reason: yup.string().when(["is_delay", "delay_responsible"], {
    is: (isDelay, responsible) => isDelay && !!responsible,
    then: (s) => s.required("Reason for delay is required"),
    otherwise: (s) => s.notRequired(),
  }),

  delay_other: yup.string().when(["is_delay", "delay_reason"], {
    is: (isDelay, reason) => isDelay && reason === "Others",
    then: (s) => s.required("Other reason is required"),
    otherwise: (s) => s.notRequired(),
  }),
});

// UPDATED: New hook for full Summary computations (per your notes)
const useSummaryComputations = (
  benefits,
  priorTrans,
  copay,
  watch,
  rnbFields,
  surgFields,
  miscFields,
  physFields,
  phFile,
  phComp,
  computed,
  surgicalComputations,
  miscComputations
) => {
  // refer to PlanAndCoverageBenefitsController
  // Build ben_basic from individual fields
  // $this->benefitMap = [
  //     'ben_lmt_ip_max_limit' => ['coverage' => 'INPATIENT', 'code' => 'ip_max_limit_basic'],
  //     'ben_lmt_ip_room_n_board' => ['coverage' => 'INPATIENT', 'code' => 'LMKIUWSQ64'],
  //     'ben_lmt_ip_misc_hospital_services' => ['coverage' => 'INPATIENT', 'code' => 'VLJETCUQOC'],
  //     'ben_lmt_ip_surgical_fee' => ['coverage' => 'INPATIENT', 'code' => 'WQTJXUBHZR'],
  //     'ben_lmt_ip_physician_fee' => ['coverage' => 'INPATIENT', 'code' => 'BXAENWLC89'],
  //     'ben_lmt_ip_opdor' => ['coverage' => 'INPATIENT', 'code' => 'KEKMDSWADP'],
  //     'ben_lmt_ip_ecu' => ['coverage' => 'INPATIENT', 'code' => 'TB71MTN9K0'],
  //     'ben_lmt_ip_surgical_fee_anes_fee' => ['coverage' => 'INPATIENT', 'code' => 'WXLZFNRUBH'],
  //     'ben_lmt_op_max_limit' => ['coverage' => 'OUTPATIENT', 'code' => 'op_max_limit_basic'],
  //     'ben_lmt_op_basic_consultation' => ['coverage' => 'OUTPATIENT', 'code' => 'MKMG7IA5AG'],
  //     'ben_lmt_op_laboratory' => ['coverage' => 'OUTPATIENT', 'code' => 'EGQIHVQB58'],
  //     'ben_lmt_op_clinic_setting' => ['coverage' => 'OUTPATIENT', 'code' => 'HYTJ8K1JTI'],
  //     'ben_lmt_op_emergency' => ['coverage' => 'OUTPATIENT', 'code' => 'CFDEASKQ19'],
  //     'ben_lmt_op_medicine' => ['coverage' => 'OUTPATIENT', 'code' => 'QAFRMMWNEL'],
  //     'ben_lmt_op_ataccess' => ['coverage' => 'OUTPATIENT', 'code' => 'YL440L5KBY'],
  //     'ben_lmt_op_medpadala' => ['coverage' => 'OUTPATIENT', 'code' => 'WTIGQLQA25'],
  //     'ben_lmt_op_mpsyche' => ['coverage' => 'OUTPATIENT', 'code' => 'MPSYCHE'],
  //     'ben_lmt_mat_max_limit' => ['coverage' => 'MATERNITY', 'code' => 'mat_max_limit_basic'],
  //     'ben_lmt_mat_normal_delivery' => ['coverage' => 'MATERNITY', 'code' => 'K20I8CQQ9T'],
  //     'ben_lmt_mat_cs_delivery' => ['coverage' => 'MATERNITY', 'code' => 'AAM69QNWLP'],
  //     'ben_lmt_mat_pre_natal' => ['coverage' => 'MATERNITY', 'code' => 'QFT8DSWXOL'],
  //     'ben_lmt_mat_post_natal' => ['coverage' => 'MATERNITY', 'code' => 'MWS9XG8X04'],
  //     'ben_lmt_ape_max_limit' => ['coverage' => 'APE', 'code' => 'ape_max_limit_basic'],
  // ];
  const BEN_MAP = {
    rnb: "LMKIUWSQ64", // ip_room_n_board' => ['coverage' => 'INPATIENT', 'code' => 'LMKIUWSQ64'
    surgical: "WQTJXUBHZR", // ip_surgical_fee' => ['coverage' => 'INPATIENT', 'code' => 'WQTJXUBHZR'
    misc: "VLJETCUQOC", // ip_misc_hospital_services' => ['coverage' => 'INPATIENT', 'code' => 'VLJETCUQOC'
    phys: "BXAENWLC89", // ip_physician_fee' => ['coverage' => 'INPATIENT', 'code' => 'BXAENWLC89'
    anes: "WXLZFNRUBH", // ip_surgical_fee_anes_fee' => ['coverage' => 'INPATIENT', 'code' => 'WXLZFNRUBH'
  };
  const RNB_OPTIONS = [
    { label: "", value: "0" },
    { label: "Ward", value: "Ward", seq: 1, rm_amt: 120, ip_rate: 0.0 },
    {
      label: "Semi-Private",
      value: "Semi-Private",
      seq: 2,
      rm_amt: 125,
      ip_rate: 0.0,
    },
    { label: "Private", value: "Private", seq: 3, rm_amt: 130, ip_rate: 0.0 },
    {
      label: "Small Private",
      value: "Small Private",
      seq: 3,
      rm_amt: 130,
      ip_rate: 0.0,
    },
    {
      label: "Regular Private",
      value: "Regular Private",
      seq: 3,
      rm_amt: 130,
      ip_rate: 0.0,
    },
    {
      label: "Large Private",
      value: "Large Private",
      seq: 3,
      rm_amt: 130,
      ip_rate: 0.0,
    },
    { label: "Suite", value: "Suite", seq: 4, rm_amt: 135, ip_rate: 0.0 },
    { label: "ICU", value: "ICU", seq: 5, rm_amt: 135, ip_rate: 0.0 },
  ]; // For room multipliers
  let totalSurPh = 0;
  return useMemo(() => {
    const summary = {};
    let totals = { incurred: 0, ph: 0, covered: 0, excess: 0, uncovered: 0 };
    let allCovered = 0; // For post-copay
    Object.keys(BEN_MAP).forEach((key) => {
      const benCode = BEN_MAP[key];
      const benefit = benefits?.[benCode] || null;
      const isNotCoveredBenefit = isBenefitNotCovered(benefit);
      let limitBasic = isNotCoveredBenefit
        ? "Not Covered"
        : getBenefitLimitValue(benefits, benCode, "basic"); // Number or string ("Private", "as charged")
      let limitMajor = isNotCoveredBenefit
        ? 0
        : getBenefitLimitValue(benefits, benCode, "major");
      // RNB specific condition
      console.log("---- RNB LIMIT CHECK ----");
      console.log("benefits:", benefits);
      if (key === "rnb" && !isNotCoveredBenefit) {
        const LMKIUWSQ64_roomType = benefits?.LMKIUWSQ64?.rnb_room_type;
        const LMKIUWSQ64_isValidRoomType =
          LMKIUWSQ64_roomType &&
          LMKIUWSQ64_roomType.toLowerCase() !== "n/a" &&
          LMKIUWSQ64_roomType.trim() !== "";
        limitBasic = LMKIUWSQ64_isValidRoomType ? limitBasic : 0;
      }
      // Remaining: Limit - prior (clamp >=0; strings as-is or unlimited)
      const remainingBasic = isNotCoveredBenefit
        ? 0
        : key === "rnb" && limitBasic === 0
          ? 0
          : getBenefitRemainingValue(benefits, benCode, "basic", priorTrans);
      const remainingMajor = isNotCoveredBenefit
        ? 0
        : getBenefitRemainingValue(
            benefits,
            benCode,
            "major",
            priorTrans
          );
      // Incurred: Sum upstream
      let incurred = 0;
      let uncoveredMisc = 0;
      switch (key) {
        case "rnb":
          incurred = rnbFields.reduce(
            (sum, _, i) => sum + toFiniteNumber(watch(`rnb_rows.${i}.amount`), 0),
            0
          );
          break;
        case "surgical":
          incurred = surgicalComputations.totalRuvAmt;
          const surgicalPhysPh = physFields.reduce((sum, _, i) => {
            const role = watch(`physician_rows.${i}.role`);
            return role === "Surgeon"
              ? sum + toFiniteNumber(watch(`physician_rows.${i}.philhealth`), 0)
              : sum;
          }, 0);
          // Include Assistant Surgeon amounts and PH in surgical incurred
          const assistantPhysAmt = physFields.reduce((sum, _, i) => {
            const role = watch(`physician_rows.${i}.role`);
            return role === "Assistant Surgeon"
              ? sum + toFiniteNumber(watch(`physician_rows.${i}.amount`), 0)
              : sum;
          }, 0);
          const assistantPhysPh = physFields.reduce((sum, _, i) => {
            const role = watch(`physician_rows.${i}.role`);
            return role === "Assistant Surgeon"
              ? sum + toFiniteNumber(watch(`physician_rows.${i}.philhealth`), 0)
              : sum;
          }, 0);
          // Add assistant surgeon fees to incurred and include their PH in totalSurPh
          incurred += assistantPhysAmt;
          totalSurPh =
            toFiniteNumber(surgicalComputations.totalSurPh, 0) +
            surgicalPhysPh +
            assistantPhysPh;
          break;
        case "misc":
          incurred = toFiniteNumber(miscComputations.totalMiscAmt, 0);
          break;
        case "phys":
          // UPDATED: Exclude Surgeons (now in surgical) and Anesthesiologists
          incurred = physFields.reduce((sum, _, i) => {
            const role = watch(`physician_rows.${i}.role`);
            return (
              sum +
              (role !== "Anesthesiologist" &&
              role !== "Surgeon" &&
              role !== "Assistant Surgeon"
                ? toFiniteNumber(watch(`physician_rows.${i}.amount`), 0)
                : 0)
            );
          }, 0);
          break;
        case "anes":
          incurred = physFields.reduce(
            (sum, _, i) =>
              sum +
              (watch(`physician_rows.${i}.role`) === "Anesthesiologist"
                ? toFiniteNumber(watch(`physician_rows.${i}.amount`), 0)
                : 0),
            0
          );
          break;
      }
      // PhilHealth: Sum upstream PH
      let philhealth = 0;
      switch (key) {
        case "rnb":
          philhealth = toFiniteNumber(watch("rnb_rows_philhealth"), 0);
          break;
        case "surgical":
          // Use the updated totalSurPh from above
          philhealth = totalSurPh;
          break;
        case "misc":
          philhealth = toFiniteNumber(miscComputations.totalMiscPh, 0);
          break;
        case "phys":
          // UPDATED: Exclude Surgeons and Anesthesiologists
          philhealth = physFields.reduce((sum, _, i) => {
            const role = watch(`physician_rows.${i}.role`);
            return (
              sum +
              (role !== "Anesthesiologist" &&
              role !== "Surgeon" &&
              role !== "Assistant Surgeon"
                ? toFiniteNumber(watch(`physician_rows.${i}.philhealth`), 0)
                : 0)
            );
          }, 0);
          break;
        case "anes":
          philhealth = physFields.reduce(
            (sum, _, i) =>
              sum +
              (watch(`physician_rows.${i}.role`) === "Anesthesiologist"
                ? toFiniteNumber(watch(`physician_rows.${i}.philhealth`), 0)
                : 0),
            0
          );
          break;
      }
      // Covered: min(remaining, incurred - philhealth); adjust for overrides
      const effectivePH = phComp ? 0 : philhealth; // If non-compensable, PH not deducted from covered
      const netIncurred = Math.max(0, incurred - effectivePH);
      if (isNotCoveredBenefit) {
        summary[key] = {
          basicLimit: limitBasic,
          majorLimit: limitMajor,
          basicRemaining: remainingBasic,
          majorRemaining: remainingMajor,
          incurred,
          philhealth,
          basicCovered: 0,
          majorCovered: 0,
          excess: netIncurred,
          isNotCovered: true,
        };
        totals.incurred += incurred;
        totals.ph += philhealth;
        totals.excess += netIncurred;
        return;
      }

      let basicCovered =
        toOptionalFiniteNumber(remainingBasic) !== null
          ? Math.min(toFiniteNumber(remainingBasic, 0), netIncurred)
          : netIncurred; // Unlimited = full after PH
      // If user entered explicit "covered" values for RNB rows, prefer that total
      if (key === "rnb") {
        try {
          const rnbRowsCoveredSum = rnbFields.reduce(
            (sum, _, i) => sum + toFiniteNumber(watch(`rnb_rows.${i}.covered`), 0),
            0
          );
          if (rnbRowsCoveredSum > 0) {
            basicCovered = rnbRowsCoveredSum;
          }
        } catch (e) {
          // watch or rnbFields may not be available in some contexts; ignore
        }
      }
      let majorCovered = 0; // Assume basic for now; extend if major flag
      // Special handling for surgical: use detailed computations
      if (key === "surgical") {
        const remBasSur = toOptionalFiniteNumber(remainingBasic);
        const remMajSur = toFiniteNumber(remainingMajor, 0);
        const incPhSur = netIncurred;
        if (remBasSur === null) {
          basicCovered = incPhSur;
          majorCovered = 0;
        } else if (incPhSur > remBasSur) {
          basicCovered = remBasSur;
          majorCovered = Math.min(remMajSur, incPhSur - remBasSur);
        } else {
          basicCovered = incPhSur;
          majorCovered = 0;
        }
      }
      // Special handling for phys: compute major logic
      if (key === "phys") {
        // Compute remaining after prior
        const remBasPhys = toOptionalFiniteNumber(remainingBasic);
        const remMajPhys = toFiniteNumber(remainingMajor, 0);
        const incPhPhys = netIncurred;
        if (remBasPhys === null) {
          basicCovered = incPhPhys;
          majorCovered = 0;
        } else if (incPhPhys > remBasPhys) {
          basicCovered = remBasPhys;
          majorCovered = Math.min(remMajPhys, incPhPhys - remBasPhys);
        } else {
          basicCovered = incPhPhys;
          majorCovered = 0;
        }
      }
      // Special handling for anes: compute major logic
      if (key === "anes") {
        // Compute remaining after prior
        const remBasAnes = toOptionalFiniteNumber(remainingBasic);
        const remMajAnes = toFiniteNumber(remainingMajor, 0);
        const incPhAnes = netIncurred;
        if (remBasAnes === null) {
          basicCovered = incPhAnes;
          majorCovered = 0;
        } else if (incPhAnes > remBasAnes) {
          basicCovered = remBasAnes;
          majorCovered = Math.min(remMajAnes, incPhAnes - remBasAnes);
        } else {
          basicCovered = incPhAnes;
          majorCovered = 0;
        }
      }
      // Copay: Apply if computed
      if (computed) {
        basicCovered = basicCovered * (1 - (copay.member || 0) / 100);
        majorCovered = majorCovered * (1 - (copay.member || 0) / 100);
      }
      // Excess: uncovered amount after PhilHealth and covered
      let excess = Math.max(0, netIncurred - (basicCovered + majorCovered));
      summary[key] = {
        basicLimit: limitBasic,
        majorLimit: limitMajor,
        basicRemaining: remainingBasic,
        majorRemaining: remainingMajor,
        incurred,
        philhealth,
        basicCovered,
        majorCovered,
        excess,
      };
      totals.incurred += incurred;
      totals.ph += philhealth;
      totals.covered += basicCovered + majorCovered;
      totals.excess += excess;
    });
    // Uncovered: Sum Misc "Uncovered Items"
    const uncoveredMisc = miscFields.reduce((sum, _, i) => {
      const part = watch(`misc_rows.${i}.particulars`);
      return (
        sum +
        (part === "Uncovered Items"
          ? toFiniteNumber(watch(`misc_rows.${i}.amount`), 0)
          : 0)
      );
    }, 0);
    totals.uncovered = uncoveredMisc;
    return { summary, totals };
  }, [
    benefits,
    priorTrans,
    copay,
    watch,
    rnbFields,
    surgFields,
    miscFields,
    physFields,
    phFile,
    phComp,
    computed,
    surgicalComputations,
    miscComputations,
  ]);
};
const tableCellBase = "border border-gray-300 px-2 py-1";
const inputBase = "w-full px-3 py-1 border rounded text-sm";
const disabledInput = "w-full px-3 py-1 bg-gray-100 text-sm";
const thBase =
  "bg-gray-100 border border-gray-300 px-2 py-1 text-xs font-medium";
const tdBase = "border border-gray-300 px-2 py-1";
const selectInputBase = `${inputBase} min-w-0 truncate`;
const benefitSummaryRows = [
  { key: "rnb", code: "LMKIUWSQ64", description: "Room & Board" },
  { key: "misc", code: "VLJETCUQOC", description: "Misc. Hospital Services" },
  { key: "surgical", code: "WQTJXUBHZR", description: "Surgical Fee" },
  { key: "phys", code: "BXAENWLC89", description: "Physician Fee" },
  { key: "anes", code: "WXLZFNRUBH", description: "Anesthesiologist Fee" },
];
const normalizeCoverageText = (value) =>
  String(value ?? "")
    .toLowerCase()
    .replace(/[^a-z]/g, "");
const isBenefitNotCovered = (benefit) => {
  if (!benefit) {
    return true;
  }

  if (benefit.is_not_covered) {
    return true;
  }

  return [
    benefit.basic_limit,
    benefit.major_limit,
    benefit.rnb_amt,
    benefit.rnb_room_type,
    benefit.total_benefit_limit,
  ].some((value) => normalizeCoverageText(value).includes("notcover"));
};
const createNotCoveredBenefit = ({ code, description }) => ({
  benefit_code: code,
  benefit_description: description,
  basic_limit: "Not Covered",
  major_limit: "0.00",
  basic_remaining: 0,
  major_remaining: 0,
  total_benefit_limit: "Not Covered",
  is_not_covered: true,
});
const normalizeDischargeBenefits = (loadedBenefits = {}) => {
  const normalizedBenefits = { ...loadedBenefits };

  benefitSummaryRows.forEach((row) => {
    if (!normalizedBenefits[row.code]) {
      normalizedBenefits[row.code] = createNotCoveredBenefit(row);
      return;
    }

    if (isBenefitNotCovered(normalizedBenefits[row.code])) {
      normalizedBenefits[row.code] = {
        ...normalizedBenefits[row.code],
        is_not_covered: true,
      };
    }
  });

  return normalizedBenefits;
};
const toFiniteNumber = (value, fallback = 0) => {
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : fallback;
  }

  if (value === null || typeof value === "undefined" || value === "") {
    return fallback;
  }

  const normalized = String(value)
    .replace(/php/gi, "")
    .replace(/₱/g, "")
    .replace(/,/g, "")
    .trim();
  if (normalized === "") return fallback;

  const num = Number(normalized);
  return Number.isFinite(num) ? num : fallback;
};
const toOptionalFiniteNumber = (value) => {
  const parsed = toFiniteNumber(value, null);
  return Number.isFinite(parsed) ? parsed : null;
};
const normalizeLimitValue = (value) => {
  if (value === null || typeof value === "undefined" || value === "") {
    return 0;
  }

  const parsed = toOptionalFiniteNumber(value);
  return parsed === null ? String(value) : parsed;
};
const getBenefitPriorUsed = (benefits, benefitCode, priorTrans = []) => {
  const benefit = benefits?.[benefitCode] || {};
  const matchedPrior = priorTrans.find((t) => t.ben_code === benefitCode);
  return toFiniteNumber(
    benefit.prior_used ??
      benefit.utilized_amount ??
      benefit.previous_used ??
      matchedPrior?.amt,
    0
  );
};
const getBenefitLimitValue = (benefits, benefitCode, type) =>
  normalizeLimitValue(benefits?.[benefitCode]?.[`${type}_limit`]);
const getBenefitRemainingValue = (benefits, benefitCode, type, priorTrans = []) => {
  const benefit = benefits?.[benefitCode] || {};
  const explicitRemaining = benefit?.[`${type}_remaining`];
  if (
    explicitRemaining !== null &&
    typeof explicitRemaining !== "undefined" &&
    explicitRemaining !== ""
  ) {
    return normalizeLimitValue(explicitRemaining);
  }

  const limit = getBenefitLimitValue(benefits, benefitCode, type);
  const limitAmount = toOptionalFiniteNumber(limit);
  if (limitAmount === null) {
    return limit;
  }

  const priorUsed = getBenefitPriorUsed(benefits, benefitCode, priorTrans);
  if (type === "major") {
    const basicLimit = toOptionalFiniteNumber(
      getBenefitLimitValue(benefits, benefitCode, "basic")
    );
    const majorUsed = basicLimit === null ? 0 : Math.max(0, priorUsed - basicLimit);
    return Math.max(0, limitAmount - majorUsed);
  }

  return Math.max(0, limitAmount - priorUsed);
};
const formatBenefitValue = (value) => {
  if (value === null || typeof value === "undefined" || value === "") {
    return "0.00";
  }

  const num = toOptionalFiniteNumber(value);
  if (num === null) {
    if (typeof value === "number") return "0.00";
    if (String(value).trim().toLowerCase() === "nan") return "0.00";
    return String(value);
  }

  return num.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
const formatBenefitMoney = (value) =>
  `PHP ${formatBenefitValue(toFiniteNumber(value, 0))}`;
const applyOverallMaxLimitCap = (totals = {}, maxLimit) => {
  const cap = toOptionalFiniteNumber(maxLimit);
  const covered = toFiniteNumber(totals.covered, 0);
  const excess = toFiniteNumber(totals.excess, 0);

  if (cap === null || cap <= 0 || covered <= cap) {
    return {
      ...totals,
      mblCapApplied: false,
      mblCapExcess: 0,
      ipMaxLimit: cap,
    };
  }

  const capExcess = covered - cap;
  return {
    ...totals,
    covered: cap,
    excess: excess + capExcess,
    mblCapApplied: true,
    mblCapExcess: capExcess,
    ipMaxLimit: cap,
  };
};
const findNegativeDischargeAmount = (payload) => {
  const topLevelFields = [
    ["total_incurred", "Total incurred"],
    ["total_philhealth", "Total PhilHealth"],
    ["total_covered", "Total covered"],
    ["total_excess", "Total excess"],
    ["total_uncovered", "Total uncovered"],
    ["guaranteed_amount", "Guaranteed amount"],
    ["uncovered_amount", "Uncovered item amount"],
    ["mbl_remaining_limit", "MBL remaining limit"],
    ["rnb_rows_philhealth", "R&B PhilHealth"],
    ["misc_rows_philhealth", "Misc PhilHealth"],
  ];

  for (const [field, label] of topLevelFields) {
    if (toFiniteNumber(payload?.[field], 0) < 0) {
      return `${label} cannot be negative`;
    }
  }

  const rowChecks = [
    ["rnb_rows", [["rate", "R&B rate"], ["amount", "R&B amount"], ["covered", "R&B covered"], ["philhealth", "R&B PhilHealth"]]],
    ["surgical_rows", [["ruv_unit", "RUV unit"], ["amount", "Surgical amount"], ["philhealth", "Surgical PhilHealth"], ["operating_room_amount", "Operating room amount"]]],
    ["physician_rows", [["amount", "Physician amount"], ["philhealth", "Physician PhilHealth"]]],
    ["misc_rows", [["amount", "Misc amount"], ["philhealth", "Misc PhilHealth"]]],
  ];

  for (const [rowsField, fields] of rowChecks) {
    const rows = Array.isArray(payload?.[rowsField]) ? payload[rowsField] : [];
    for (let index = 0; index < rows.length; index += 1) {
      for (const [field, label] of fields) {
        if (toFiniteNumber(rows[index]?.[field], 0) < 0) {
          return `${label} row ${index + 1} cannot be negative`;
        }
      }
    }
  }

  return "";
};
const createCompactSelectStyles = (menuWidth) => ({
  container: (base) => ({ ...base, minWidth: 0 }),
  control: (base) => ({ ...base, minWidth: 0 }),
  valueContainer: (base) => ({
    ...base,
    minWidth: 0,
    overflow: "hidden",
  }),
  singleValue: (base) => ({
    ...base,
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  }),
  placeholder: (base) => ({
    ...base,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  }),
  input: (base) => ({ ...base, minWidth: 0 }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
    ...(menuWidth
      ? { width: menuWidth, maxWidth: "calc(100vw - 32px)" }
      : {}),
  }),
  option: (base) => ({
    ...base,
    whiteSpace: "normal",
    wordBreak: "normal",
    overflowWrap: "break-word",
    lineHeight: 1.35,
  }),
});
const compactSelectStyles = createCompactSelectStyles();
const ruvSelectStyles = createCompactSelectStyles("36rem");
const physicianSelectStyles = createCompactSelectStyles("32rem");
const getSelectLabelText = (option) =>
  String(
    option?.label ||
      option?.full_name ||
      option?.full_name_w_id ||
      option?.raw?.label ||
      option?.raw?.full_name ||
      option?.value ||
      ""
  )
    .replace(/\s+/g, " ")
    .trim();
const formatCompactSelectLabel = (option, { context }) => {
  const label = getSelectLabelText(option) || "N/A";
  const isMenu = context === "menu";
  return (
    <div
      className={`min-w-0 text-sm text-gray-900 ${
        isMenu ? "whitespace-normal break-words leading-snug" : "truncate"
      }`}
      title={label}
    >
      {label}
    </div>
  );
};
const ConfinementInformationTab = ({
  transNo,
  onSuccess,
  onCancel,
  benefits: planBenefits,
  priorTrans = [],
  copay = { member: 0, company: 0 },
}) => {
  // UPDATED: Added props for computations
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [details, setDetails] = useState(null);
  const [benefits, setBenefits] = useState(() =>
    normalizeDischargeBenefits(planBenefits || {})
  ); // UPDATED: From prop
  const [physicians, setPhysicians] = useState([]);
  const [onlyAffiliated, setOnlyAffiliated] = useState(false);
  const [miscServices, setMiscServices] = useState([]);
  const [showDelay, setShowDelay] = useState(false);
  const [editingDisabled, setEditingDisabled] = useState(false);
  const [mblRemainingLimit, setMblRemainingLimit] = useState(0);
  const [delayResponsible, setDelayResponsible] = useState("");
  const [finalizeLoading, setFinalizeLoading] = useState(false);
  const [computed, setComputed] = useState(false); // UPDATED: For finalize lock
  const [claimSyncData, setClaimSyncData] = useState(null);
  const [claimSyncLoading, setClaimSyncLoading] = useState(false);
  // New separate states for ICD selects
  const [selectedInitialIcd, setSelectedInitialIcd] = useState(null);
  const [selectedFinalIcd, setSelectedFinalIcd] = useState(null);
  // New: State for RVU selects (object keyed by field.id to avoid conflicts in multi-rows)
  const [selectedRvus, setSelectedRvus] = useState({});
  // New: State to track manual amount edits per surgical row
  const [manualAmounts, setManualAmounts] = useState({});
  // AI ICD Search chat states
  const [aiChatOpen, setAiChatOpen] = useState(false);
  const [aiMessages, setAiMessages] = useState([
    {
      id: 1,
      role: "assistant",
      text: "Hi! Ask me to search ICD codes. Example: 'What is the ICD code for UPPER GI BLEEDING due to BLEEDING PEPTIC ULCER?'",
    },
  ]);
  const [aiInput, setAiInput] = useState("");
  const [aiLoading, setAiLoading] = useState(false);

  // Summary Modal states
  const [showSummaryModal, setShowSummaryModal] = useState(false);
  const [summaryData, setSummaryData] = useState(null);
  const [summaryModalTab, setSummaryModalTab] = useState("discharge");
  const [openSections, setOpenSections] = useState({ member: true, provider: true, finance: true, pf: true, backend: false });
  const [confirmingDischarge, setConfirmingDischarge] = useState(false);
  const [isMaximized, setIsMaximized] = useState(false);

  // markdown rendering moved to reusable AiIcdChat component

  // Component for modal action buttons
  const ModalActionButtons = ({ onCancel, onConfirm, confirming, totalApproved }) => (
    <div className="flex flex-wrap justify-end gap-3">
      <button
        onClick={onCancel}
        className="px-4 py-2 border border-gray-300 rounded text-gray-700 hover:bg-gray-50"
        disabled={confirming}
      >
        Cancel
      </button>
      <button
        onClick={async () => {
          const result = await MySwal.fire({
            title: 'Confirm Discharge',
            text: `Are you sure you want to proceed with the discharge? Total Approved Amount: ${formatBenefitMoney(totalApproved)}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, proceed'
          });

          if (result.isConfirmed) {
            await onConfirm();
          }
        }}
        className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 disabled:opacity-50 flex items-center space-x-2"
        disabled={confirming}
      >
        {confirming && <FontAwesomeIcon icon={faSpinner} spin />}
        <span>{confirming ? 'Processing...' : 'Confirm & Proceed to Discharge'}</span>
      </button>
    </div>
  );

  const openAiChat = (prefill) => {
    if (!ENABLE_AI_ICD_SEARCH) return;

    setAiChatOpen(true);
    if (prefill) setAiInput(prefill);
    else {
      try {
        const fd = watch("final_diagnosis");
        if (fd) setAiInput(`Final Diagnosis: ${fd}`);
      } catch (e) {
        // watch may not be available at initial render
      }
    }
  };

  const closeAiChat = () => setAiChatOpen(false);

  const sendAiMessage = async (message) => {
    if (!ENABLE_AI_ICD_SEARCH) return;

    if (!message || aiLoading) return;
    const userMsg = { id: Date.now(), role: "user", text: message };
    setAiMessages((p) => [...p, userMsg]);
    setAiInput("");
    setAiLoading(true);

    try {
      const resp = await axios.post(
        `${BASE_URL}/icd-code-search-ai`,
        { question: message },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authentication/token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      const aiData = resp.data?.data;
      let aiText = "";
      if (!aiData) {
        aiText = "No response from AI.";
      } else if (typeof aiData === "string") {
        aiText = aiData;
      } else if (aiData.choices && aiData.choices.length) {
        aiText =
          aiData.choices[0]?.message?.content || aiData.choices[0]?.text || JSON.stringify(aiData);
      } else if (aiData.message) {
        aiText = aiData.message;
      } else {
        aiText = JSON.stringify(aiData);
      }

      const botMsg = { id: Date.now() + 1, role: "assistant", text: aiText };
      setAiMessages((p) => [...p, botMsg]);
    } catch (error) {
      const errMsg = error.response?.data?.message || error.message || "AI request failed";
      setAiMessages((p) => [...p, { id: Date.now() + 1, role: "assistant", text: `Error: ${errMsg}` }]);
      toast.error("Failed to fetch AI ICD suggestions");
    } finally {
      setAiLoading(false);
    }
  };
  // Upload states for Proof of Guarantee
  const [proofFiles, setProofFiles] = useState([]);
  const [proofFormData, setProofFormData] = useState({
    proof_guarantee_upload: "[]",
  });
  // Track last seen Amount per RNB row (keyed by field.id) to detect changes
  const [rnbLastAmt, setRnbLastAmt] = useState({});
  const proofFileInputRef = useRef(null);
  const hasShownRnbDaysMismatchToastRef = useRef(false);
  const [isDraggingProof, setIsDraggingProof] = useState(false);
  // Upload states for Final SOA Files
  const [soaFiles, setSoaFiles] = useState([]);
  const [soaFormData, setSoaFormData] = useState({ soa_fileupload: "[]" });
  const soaFileInputRef = useRef(null);
  const [isDraggingSoa, setIsDraggingSoa] = useState(false);
  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    formState: { errors },
    trigger,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      rnb_rows: [
        { room_type: "", room_no: "", rate: 0, days: 1, amount: 0, covered: 0 },
      ],
      rnb_rows_philhealth: 0,
      physician_rows: [{ physician_id: null,physician: "", role: "", amount: 0, philhealth: 0 }],
      surgical_rows: [
        {
          rvu_code: "",
          ruv_description: "",
          remarks: "",
          rnb_type: "",
          ruv_unit: 0,
          amount: 0,
          philhealth: 0,
          operating_room_amount: 0,
        },
      ],
      misc_rows: [],
      misc_rows_philhealth: 0,
      corporate_guarantee: false,
      provider_guarantee: false,
      ph_file: false,
      ph_comp: false,
      show_delay: false,
      member_share_amount: 0,
      proof_guarantee_upload: "[]",
      soa_fileupload: "[]",
      soa_received_date: getCurrentDateTimeLocal(),
    },
  });
  const {
    fields: rnbFields,
    append: appendRnb,
    remove: removeRnb,
  } = useFieldArray({ control, name: "rnb_rows" });

  // ensure last-amount entries exist for each field id (will initialize later)
  useEffect(() => {
    const toAdd = {};
    rnbFields.forEach((f) => {
      if (!(f.id in rnbLastAmt)) toAdd[f.id] = 0;
    });
    if (Object.keys(toAdd).length) setRnbLastAmt((p) => ({ ...p, ...toAdd }));
  }, [rnbFields.length]);

  // When amount changes (via rate/days changes), update covered unless user manually edited covered

  const {
    fields: physFields,
    append: appendPhys,
    remove: removePhys,
    replace: replacePhys,
  } = useFieldArray({ control, name: "physician_rows" });
  const {
    fields: surgFields,
    append: appendSurg,
    remove: removeSurg,
  } = useFieldArray({ control, name: "surgical_rows" });
  const {
    fields: miscFields,
    append: appendMisc,
    remove: removeMisc,
  } = useFieldArray({ control, name: "misc_rows" });
  const phFile = watch("ph_file");
  const phComp = watch("ph_comp");
  const corporateGuarantee = watch("corporate_guarantee");
  const providerGuarantee = watch("provider_guarantee");
  const delayResponsibleWatch = watch("delay_responsible");
  // Watch surgical rows for reactivity
  const surgicalRows = useWatch({
    control,
    name: "surgical_rows",
    defaultValue: [],
  });
  // Watch physician rows for real-time totals
  const physicianRows = useWatch({
    control,
    name: "physician_rows",
    defaultValue: [],
  });
  // Watch misc rows for reactivity
  const miscRows = useWatch({
    control,
    name: "misc_rows",
    defaultValue: [],
  });
  // Watch RNB rows and admission/discharge to trigger realtime updates
  const rnbRowsWatch = useWatch({
    control,
    name: "rnb_rows",
    defaultValue: [],
  });
  const claimSyncFinalDiagnosis = claimSyncData?.final_diagnosis || {};
  const hasClaimSyncFinalDiagnosis = Boolean(
    claimSyncFinalDiagnosis?.sync_available && claimSyncFinalDiagnosis?.option
  );
  const claimSyncPhysicians = Array.isArray(claimSyncData?.physicians)
    ? claimSyncData.physicians
    : [];
  const hasClaimSyncPhysicians = claimSyncPhysicians.length > 0;
  const claimSyncRemarks = String(claimSyncData?.claim_remarks?.value || "");
  const hasClaimSyncRemarks = claimSyncRemarks.trim() !== "";
  // When amount changes (via rate/days changes), update covered unless user manually edited covered
  useEffect(() => {
    // Build a new lastAmt mapping and update covered only when amount changed
    const newLast = { ...rnbLastAmt };
    let changed = false;
    rnbFields.forEach((field, idx) => {
      const amt = toFiniteNumber(rnbRowsWatch[idx]?.amount, 0);
      const prev = rnbLastAmt[field.id];
      if (typeof prev === "undefined") {
        newLast[field.id] = amt;
        setValue(`rnb_rows.${idx}.covered`, amt);
        changed = true;
      } else if (prev !== amt) {
        // amount changed -> overwrite covered with new amount
        newLast[field.id] = amt;
        setValue(`rnb_rows.${idx}.covered`, amt);
        changed = true;
      }
    });
    if (changed) setRnbLastAmt(newLast);
  }, [rnbRowsWatch, rnbFields.length, rnbLastAmt]);
  const admissionWatch = useWatch({
    control,
    name: "admission_date",
    defaultValue: "",
  });
  const dischargeWatch = useWatch({
    control,
    name: "discharged_date",
    defaultValue: "",
  });
  const miscPhilhealth = useWatch({
    control,
    name: "misc_rows_philhealth",
    defaultValue: 0,
  });
  // ################ COMPUTATIONS: ###########
  const RNB_OPTIONS = [
    { label: "", value: "0" },
    { label: "Ward", value: "Ward", seq: 1, rm_amt: 120, ip_rate: 0.0 },
    {
      label: "Semi-Private",
      value: "Semi-Private",
      seq: 2,
      rm_amt: 125,
      ip_rate: 0.0,
    },
    { label: "Private", value: "Private", seq: 3, rm_amt: 130, ip_rate: 0.0 },
    {
      label: "Small Private",
      value: "Small Private",
      seq: 3,
      rm_amt: 130,
      ip_rate: 0.0,
    },
    {
      label: "Regular Private",
      value: "Regular Private",
      seq: 3,
      rm_amt: 130,
      ip_rate: 0.0,
    },
    {
      label: "Large Private",
      value: "Large Private",
      seq: 3,
      rm_amt: 130,
      ip_rate: 0.0,
    },
    { label: "Suite", value: "Suite", seq: 4, rm_amt: 135, ip_rate: 0.0 },
    { label: "ICU", value: "ICU", seq: 5, rm_amt: 135, ip_rate: 0.0 },
  ];
  // Surgical Computations - Updated to use watched amounts without overwriting
  const surgicalComputations = useMemo(() => {
    let totalRvuUnit = 0;
    let totalRuvAmt = 0;
    let totalSurPh = 0;
    let totalOr = 0;
    const remBasSurRaw = getBenefitRemainingValue(
      benefits,
      "WQTJXUBHZR",
      "basic",
      priorTrans
    );
    const remMajSur = toFiniteNumber(
      getBenefitRemainingValue(benefits, "WQTJXUBHZR", "major", priorTrans),
      0
    );
    const remBasSur = toOptionalFiniteNumber(remBasSurRaw);
    surgicalRows.forEach((row) => {
      if (!row) return;
      const ruvUnit = toFiniteNumber(row.ruv_unit, 0);
      const amount = toFiniteNumber(row.amount, 0);
      const ph = toFiniteNumber(row.philhealth, 0);
      const orAmt = toFiniteNumber(row.operating_room_amount, 0);
      // DEBUG LOGS
      console.log("---- Surgical Benefit or RUV/RVU COMPUTATIONS ROW ----");
      console.log("ruvUnit:", ruvUnit);
      console.log("amount (watched):", amount);
      console.log("philhealth:", ph);
      console.log("operating_room_amount:", orAmt);
      console.log("------------------------");
      totalRvuUnit += ruvUnit;
      totalRuvAmt += amount;
      totalSurPh += ph;
      totalOr += orAmt;
    });
    const incPhSur = Math.max(0, totalRuvAmt - (phComp ? 0 : totalSurPh));
    const covSur = remBasSur === null ? incPhSur : Math.min(incPhSur, remBasSur);
    const covSurMaj =
      remBasSur === null
        ? 0
        : Math.min(Math.max(0, incPhSur - remBasSur), remMajSur);
    const totalCovSur = covSur + covSurMaj;
    const totalExcSur = Math.max(0, incPhSur - totalCovSur);
    return {
      totalRvuUnit,
      totalRuvAmt,
      totalSurPh,
      totalOr,
      covSur,
      covSurMaj,
      totalCovSur,
      totalExcSur,
    };
  }, [surgFields.length, surgicalRows, benefits, priorTrans, phComp]);
  // Misc Computations - Similar to surgical
  const miscComputations = useMemo(() => {
    let totalMiscAmt = 0;
    const totalMiscPh = toFiniteNumber(miscPhilhealth, 0);
    const remBasMiscRaw = getBenefitRemainingValue(
      benefits,
      "VLJETCUQOC",
      "basic",
      priorTrans
    );
    const remMajMisc = toFiniteNumber(
      getBenefitRemainingValue(benefits, "VLJETCUQOC", "major", priorTrans),
      0
    );
    const remBasMisc = toOptionalFiniteNumber(remBasMiscRaw);
    miscRows.forEach((row) => {
      if (!row) return;
      const particulars = row.particulars;
      if (particulars === "Uncovered Items") return;
      const amount = toFiniteNumber(row.amount, 0);
      totalMiscAmt += amount;
    });
    const incPhMisc = Math.max(0, totalMiscAmt - totalMiscPh);
    const covMisc =
      remBasMisc === null ? incPhMisc : Math.min(incPhMisc, remBasMisc);
    const covMiscMaj =
      remBasMisc === null
        ? 0
        : Math.min(Math.max(0, incPhMisc - remBasMisc), remMajMisc);
    const totalCovMisc = covMisc + covMiscMaj;
    const totalExcMisc = Math.max(0, incPhMisc - totalCovMisc);
    return {
      totalMiscAmt,
      totalMiscPh,
      covMisc,
      covMiscMaj,
      totalCovMisc,
      totalExcMisc,
    };
  }, [miscRows, miscPhilhealth, benefits, priorTrans]);
  // UPDATED: Physician-specific computations for new totals
  const surgicalPhysAmount = useMemo(() => {
    return physicianRows.reduce((sum, row) => {
      const role = row?.role;
      return role === "Surgeon" ? sum + toFiniteNumber(row?.amount, 0) : sum;
    }, 0);
  }, [physicianRows]);
  const surgicalPhysPh = useMemo(() => {
    return physicianRows.reduce((sum, row) => {
      const role = row?.role;
      return role === "Surgeon" ? sum + toFiniteNumber(row?.philhealth, 0) : sum;
    }, 0);
  }, [physicianRows]);
  const anesAmount = useMemo(() => {
    return physicianRows.reduce((sum, row) => {
      const role = row?.role;
      return role === "Anesthesiologist" ? sum + toFiniteNumber(row?.amount, 0) : sum;
    }, 0);
  }, [physicianRows]);
  const anesPh = useMemo(() => {
    return physicianRows.reduce((sum, row) => {
      const role = row?.role;
      return role === "Anesthesiologist"
        ? sum + toFiniteNumber(row?.philhealth, 0)
        : sum;
    }, 0);
  }, [physicianRows]);
  // UPDATED: Full Summary computations hook
  const { summary, totals } = useSummaryComputations(
    benefits,
    priorTrans,
    copay,
    watch,
    rnbFields,
    surgFields,
    miscFields,
    physFields,
    phFile,
    phComp,
    computed,
    surgicalComputations,
    miscComputations
  );
  const inpatientMaxLimit = details?.benefits?.ip_max_limit ?? mblRemainingLimit;
  const cappedTotals = useMemo(
    () => applyOverallMaxLimitCap(totals, inpatientMaxLimit),
    [totals, inpatientMaxLimit]
  );
  // Update editing disabled based on PhilHealth checkboxes
  useEffect(() => {
    const disabled = phFile || phComp;
    setEditingDisabled(disabled);
    if (disabled) {
      toast.info(
        'Editing Disabled. Please uncheck the "Member did not file PhilHealth" or "PhilHealth Non-Compensable" checkbox first.'
      );
    }
  }, [phFile, phComp]);
  // Show/hide delay based on responsible
  useEffect(() => {
    setShowDelay(!!delayResponsibleWatch);
  }, [delayResponsibleWatch]);
  // Sync upload data to form
  useEffect(() => {
    setValue("proof_guarantee_upload", proofFormData.proof_guarantee_upload);
  }, [proofFormData, setValue]);
  useEffect(() => {
    setValue("soa_fileupload", soaFormData.soa_fileupload);
  }, [soaFormData, setValue]);
  // New: Workaround for pre-populating selected from form value (dummy option until full load)
  useEffect(() => {
    const initialDiag = watch("initial_diagnosis");
    if (initialDiag && !selectedInitialIcd) {
      setSelectedInitialIcd({ value: initialDiag, label: initialDiag });
    }
  }, [watch("initial_diagnosis"), selectedInitialIcd, setValue]);
  useEffect(() => {
    const finalDiag = watch("final_diagnosis");
    if (finalDiag && !selectedFinalIcd) {
      setSelectedFinalIcd({ value: finalDiag, label: finalDiag });
    }
  }, [watch("final_diagnosis"), selectedFinalIcd, setValue]);
  // New: Initialize selectedRvus on surgFields change
  useEffect(() => {
    const newSelectedRvus = {};
    surgFields.forEach((field) => {
      if (!(field.id in selectedRvus)) {
        newSelectedRvus[field.id] = null;
      }
    });
    setSelectedRvus((prev) => ({ ...prev, ...newSelectedRvus }));
  }, [surgFields.length]);
  // Fetch details and uploaded files on mount
  useEffect(() => {
    if (transNo) {
      fetchDetails(transNo);
      fetchClaimProcessingSyncData(transNo);
      loadDropdownData();
      fetchUploadedFiles(transNo);
    }
  }, [transNo]);
  const calculateDaysConfined = () => {
    const adm = admissionWatch;
    const dis = dischargeWatch;
    if (adm && dis)
      return differenceInCalendarDays(parseISO(dis), parseISO(adm)) + 1;
    return 0;
  };
  // const calculateTotalRnbDays = () =>
  // rnbFields.reduce(
  // (sum, _, i) => sum + (watch(`rnb_rows.${i}.days`) || 0),
  // 0
  // );
  const calculateTotalRnbDays = () =>
    (rnbRowsWatch || []).reduce((sum, row) => {
      const val = parseInt(row?.days || 0, 10) || 0;
      return sum + val;
    }, 0);
  const matchTotalDaysConfine = () => {
    const daysConfined = calculateDaysConfined();
    const totalRnbDays = calculateTotalRnbDays();
    // console.log(daysConfined)
    // console.log(totalRnbDays)
    if (daysConfined && totalRnbDays && daysConfined !== totalRnbDays) {
      if (!hasShownRnbDaysMismatchToastRef.current) {
        toast.error(RNB_DAYS_MISMATCH_MESSAGE, {
          toastId: RNB_DAYS_MISMATCH_TOAST_ID,
        });
        hasShownRnbDaysMismatchToastRef.current = true;
      }
      return;
    }
    if (hasShownRnbDaysMismatchToastRef.current) {
      toast.dismiss(RNB_DAYS_MISMATCH_TOAST_ID);
      hasShownRnbDaysMismatchToastRef.current = false;
    }
    // else {
    // toast.success("Days confined matches total Room & Board Days.");
    // }
  };
  // Validate days match on change
  useEffect(() => {
    matchTotalDaysConfine();
  }, [dischargeWatch, rnbRowsWatch]);

  // UPDATED: handleFinalizeComputation - Full validation + copay + lock
  const handleFinalizeComputation = useCallback(async () => {

    console.log("currently hindi na ginagamit ito. Finalizing computation...");
    return;

    setFinalizeLoading(true);
    try {
      // Validation: Blank roles red (simulate via toast)
      let blankRole = false;
      physFields.forEach((_, i) => {
        const role = watch(`physician_rows.${i}.role`);
        const phys = watch(`physician_rows.${i}.physician`);
        if (phys && !role) blankRole = true;
      });
      if (blankRole) {
        toast.error(
          "Invalid Physician Role: Please select valid role for the physician."
        );
        return;
      }
      // Surgeon if RUV >0
      if (surgicalComputations.totalRvuUnit > 0) {
        const hasSurgeon = physFields.some(
          (_, i) => watch(`physician_rows.${i}.role`) === "Surgeon"
        );
        if (!hasSurgeon) {
          toast.error(
            "No Surgeon Selected: Surgical procedure requires a surgeon."
          );
          return;
        }
      }
      // Anes/Assistant: Disable if RUV <200 (already in select, but re-check)
      if (surgicalComputations.totalRvuUnit < 200) {
        physFields.forEach((_, i) => {
          if (watch(`physician_rows.${i}.role`) === "Assistant Surgeon") {
            setValue(`physician_rows.${i}.role`, "");
          }
        });
      }
      // Apply copay (already in hook via computed=true)
      setComputed(true);
      toast.success("Computation finalized successfully");
      // Optional: API call for batch compute if needed
    } catch (error) {
      toast.error("Failed to finalize computation");
    } finally {
      setFinalizeLoading(false);
    }
  }, [physFields, watch, surgicalComputations, setValue, setComputed]);

  // onSubmit error
  const onError = (errors) => {
    const firstError = Object.values(errors)[0]?.message;
    // MySwal.fire({
    //   icon: "error",
    //   title: "Validation Error",
    //   text: firstError,
    // });
    toast.error(firstError);
    return;
  };

  const onSubmit = async (formData) => {
    // let retainEditingDisabledValue = editingDisabled;
    // if(editingDisabled) {
    //   setEditingDisabled(false);
    // }
    console.log(formData);
    // alert("Submit here!");
    // return;
    // Manual validation for file attachments
    try {
      const proofFilesParsed = JSON.parse(
        formData.proof_guarantee_upload || "[]"
      );
      const soaFilesParsed = JSON.parse(formData.soa_fileupload || "[]");

      if (formData.corporate_guarantee && proofFilesParsed.length === 0) {
        // alert("required Attach Proof of Guarantee");
        toast.error("required Attach Proof of Guarantee");
        // setEditingDisabled(retainEditingDisabledValue);
        return;
      }

      if (soaFilesParsed.length === 0) {
        toast.error("required Attach Final SOA Files *");
        // setEditingDisabled(retainEditingDisabledValue);
        return;
      }
    } catch (parseError) {
      // console.log("Error parsing file data:", parseError);
      toast.error("Error validating file attachments");
      // setEditingDisabled(retainEditingDisabledValue);
      return;
    }

    setSubmitting(true);
    try {
      // MERGE ALL COMPUTED TOTALS INTO FORM DATA
      const finalPayload = {
        ...formData,
        final_diagnosis_id: selectedFinalIcd?.id || null,
        final_diagnosis_icd_10_cm: selectedFinalIcd?.value || null,

        // From your useSummaryComputations hook
        total_incurred: cappedTotals.incurred,
        total_philhealth: cappedTotals.ph || 0,
        total_covered: cappedTotals.covered,
        total_excess: cappedTotals.excess,
        total_uncovered: cappedTotals.uncovered || 0,

        // Optional: isama ang breakdown per benefit
        summary: {
          rnb: summary.rnb || {},
          surgical: summary.surgical || {},
          misc: summary.misc || {},
          phys: summary.phys || {},
          anes: summary.anes || {},
        },

        // Additional helpful fields
        computed: computed, // true kapag na-finalize na
        mbl_remaining_limit: mblRemainingLimit,
      };

      console.log("Final Payload to API:", finalPayload);

      // Ensure disabled PhilHealth-related fields are still present in payload.
      // Use the field arrays (from useFieldArray) to determine indexes so that
      // fields registered with `disabled` are still collected via `watch()`.
      const normalizeFromFields = (name, length, keys) => {
        const result = [];
        for (let idx = 0; idx < length; idx++) {
          const itemFromForm = (formData[name] && formData[name][idx]) || {};
          const entry = { ...itemFromForm };
          keys.forEach((k) => {
            const w = watch(`${name}.${idx}.${k}`);
            if (typeof w !== "undefined") entry[k] = w;
          });
          result.push(entry);
        }
        return result;
      };

      finalPayload.rnb_rows = normalizeFromFields(
        "rnb_rows",
        rnbFields.length || 0,
        [
          "room_type",
          "room_no",
          "rate",
          "days",
          "amount",
          "covered",
          "philhealth",
        ]
      );
      finalPayload.rnb_rows_philhealth =
        typeof watch("rnb_rows_philhealth") !== "undefined"
          ? watch("rnb_rows_philhealth")
          : finalPayload.rnb_rows_philhealth || 0;

      finalPayload.physician_rows = normalizeFromFields(
        "physician_rows",
        physFields.length || 0,
        ["physician_id", "physician", "role", "amount", "philhealth"]
      );

      finalPayload.surgical_rows = normalizeFromFields(
        "surgical_rows",
        surgFields.length || 0,
        [
          "rvu_code",
          "ruv_description",
          "remarks",
          "rnb_type",
          "ruv_unit",
          "amount",
          "philhealth",
          "operating_room_amount",
        ]
      );

      finalPayload.misc_rows = normalizeFromFields(
        "misc_rows",
        miscFields.length || 0,
        ["particulars", "amount", "philhealth"]
      );
      finalPayload.misc_rows_philhealth =
        typeof watch("misc_rows_philhealth") !== "undefined"
          ? watch("misc_rows_philhealth")
          : finalPayload.misc_rows_philhealth || 0;

      const negativeAmountError = findNegativeDischargeAmount(finalPayload);
      if (negativeAmountError) {
        toast.error(negativeAmountError);
        return;
      }

      // const formData = new FormData();
      // formData.append("file", fileObj.file);

      // const response = await axios.post(
      //   `${BASE_URL}/api/messages/upload-file`,
      //   formData,
      //   {
      //     headers: {
      //       Authorization: `Bearer ${localStorage.getItem("authentication/token")}`,
      //       "Content-Type": "multipart/form-data",
      //     },
      //     onUploadProgress: (progressEvent) => {
      //       const progress = Math.round(
      //         (progressEvent.loaded * 100) / progressEvent.total
      //       );
      //       setFiles((prevFiles) =>
      //         prevFiles.map((f) =>
      //           f.file === fileObj.file ? { ...f, progress } : f
      //         )
      //       );
      //     },
      //   }
      // );

      // First, get summary
      const summaryResponse = await axios.post(
        `${BASE_URL}/discharge/${transNo}/process-discharge?summary=1`,
        finalPayload,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              "authentication/token"
            )}`,
          },
        }
      );

      // Show summary modal
      const responseData = summaryResponse.data.data || {};
      const responseSummary = responseData.summary || {};
      setSummaryData({
        ...responseData,
        summary: {
          ...responseSummary,
          financial: {
            ...(responseSummary.financial || {}),
            total_covered: cappedTotals.covered,
            total_excess: cappedTotals.excess,
            ip_max_limit: cappedTotals.ipMaxLimit,
            ip_remaining_limit: mblRemainingLimit,
            mbl_cap_applied: cappedTotals.mblCapApplied,
            mbl_cap_excess: cappedTotals.mblCapExcess,
          },
        },
        benefit_summary: finalPayload.summary || {},
        benefit_totals: {
          incurred: cappedTotals.incurred || 0,
          philhealth: cappedTotals.ph || 0,
          covered: cappedTotals.covered || 0,
          excess: cappedTotals.excess || 0,
          uncovered: cappedTotals.uncovered || 0,
          mblCapApplied: cappedTotals.mblCapApplied,
          mblCapExcess: cappedTotals.mblCapExcess,
          ipMaxLimit: cappedTotals.ipMaxLimit,
          ipRemainingLimit: mblRemainingLimit,
        },
      });
      setSummaryModalTab("discharge");
      setShowSummaryModal(true);
    } catch (error) {
      const errorMessage = formatErrorMessage(error);
      toast.error(errorMessage);
    } finally {
      setSubmitting(false);
      // setEditingDisabled(retainEditingDisabledValue);
    }
  };

  // Helper function to format error messages
  const formatErrorMessage = (error) => {
    if (error.response && error.response.data) {
      const data = error.response.data;

      // If it's a validation error with field-specific messages
      if (data.message && typeof data.message === 'object') {
        const messages = [];
        Object.entries(data.message).forEach(([field, errors]) => {
          if (Array.isArray(errors)) {
            errors.forEach(error => messages.push(`${field}: ${error}`));
          } else {
            messages.push(`${field}: ${errors}`);
          }
        });
        return messages.join('\n');
      }

      // If it's a simple error message
      if (data.message && typeof data.message === 'string') {
        return data.message;
      }
    }

    // Fallback to generic message
    return "Failed to process discharge";
  };

  const handleConfirmDischarge = async () => {
    setConfirmingDischarge(true);
    try {
      // Get the same payload again
      const formData = watch();
      const finalPayload = {
        ...formData,
        final_diagnosis_id: selectedFinalIcd?.id || null,
        final_diagnosis_icd_10_cm: selectedFinalIcd?.value || null,
        total_incurred: cappedTotals.incurred,
        total_philhealth: cappedTotals.ph || 0,
        total_covered: cappedTotals.covered,
        total_excess: cappedTotals.excess,
        total_uncovered: cappedTotals.uncovered || 0,
        summary: {
          rnb: summary.rnb || {},
          surgical: summary.surgical || {},
          misc: summary.misc || {},
          phys: summary.phys || {},
          anes: summary.anes || {},
        },
        computed: computed,
        mbl_remaining_limit: mblRemainingLimit,
      };

      // Normalize fields again
      const normalizeFromFields = (name, length, keys) => {
        const result = [];
        for (let idx = 0; idx < length; idx++) {
          const itemFromForm = (formData[name] && formData[name][idx]) || {};
          const entry = { ...itemFromForm };
          keys.forEach((k) => {
            const w = watch(`${name}.${idx}.${k}`);
            if (typeof w !== "undefined") entry[k] = w;
          });
          result.push(entry);
        }
        return result;
      };

      finalPayload.rnb_rows = normalizeFromFields(
        "rnb_rows",
        rnbFields.length || 0,
        ["room_type", "room_no", "rate", "days", "amount", "covered", "philhealth"]
      );
      finalPayload.rnb_rows_philhealth = watch("rnb_rows_philhealth") || 0;

      finalPayload.physician_rows = normalizeFromFields(
        "physician_rows",
        physFields.length || 0,
        ["physician_id", "physician", "role", "amount", "philhealth"]
      );

      finalPayload.surgical_rows = normalizeFromFields(
        "surgical_rows",
        surgFields.length || 0,
        ["rvu_code", "ruv_description", "remarks", "rnb_type", "ruv_unit", "amount", "philhealth", "operating_room_amount"]
      );

      finalPayload.misc_rows = normalizeFromFields(
        "misc_rows",
        miscFields.length || 0,
        ["particulars", "amount", "philhealth"]
      );
      finalPayload.misc_rows_philhealth = watch("misc_rows_philhealth") || 0;

      const negativeAmountError = findNegativeDischargeAmount(finalPayload);
      if (negativeAmountError) {
        toast.error(negativeAmountError);
        return;
      }

      // Now process actual discharge
      const response = await axios.post(
        `${BASE_URL}/discharge/${transNo}/process-discharge`,
        finalPayload,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authentication/token")}`,
          },
        }
      );

      toast.success(`Discharge processed successfully. LOA: ${response.data.data.loa_no}`);
      setShowSummaryModal(false);
      onSuccess?.(response.data.data);
    } catch (error) {
      const errorMessage = formatErrorMessage(error);
      toast.error(errorMessage);
    } finally {
      setConfirmingDischarge(false);
    }
  };
  // Removed old loadICDOptions, loadPhysicianOptions, loadRuvOptions - add back if needed for other selects
  const loadPhysicianOptions = async (inputValue, affiliated = false) => {
    if (!inputValue) return [];
    // const response = await axios.get(
    // `${BASE_URL}/discharge/physicians/${details?.transaction?.provider_code}`
    // );

    const params = {
      q: inputValue,
      limit: 20,
      // affiliated: affiliated ? true : false,
      affiliated: affiliated ? 1 : 0, // sa backend ang true is 1, at ang 0 is false
    };
    const response = await axios.get(
      `${BASE_URL}/discharge/physicians/${details?.transaction?.provider_code}`,
      {
        params,
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "authentication/token"
          )}`,
        },
      }
    );
    return response.data.data.map((phys) => {
      const physicianName =
        String(
          phys.full_name ||
            phys.label ||
            phys.full_name_w_id ||
            [phys.first_name, phys.middle_name, phys.last_name]
              .filter(Boolean)
              .join(" ")
        )
          .replace(/\s+/g, " ")
          .trim() || "Unnamed Physician";
      return {
        value: phys.id || phys.physician_id || phys.value,
        label: physicianName,
        full_name: physicianName,
        first_name: phys.first_name,
        middle_name: phys.middle_name,
        last_name: phys.last_name,
        is_affiliated: phys.is_affiliated,
        affiliation_status: phys.affiliation_status,
        // preserve any other fields if needed
        raw: phys,
      };
    });
  };
  const fetchUploadedFiles = async (transNo) => {
    try {
      const [proofRes, soaRes] = await Promise.all([
        axios.get(`${BASE_URL}/discharge/uploads/${transNo}/proof`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              "authentication/token"
            )}`,
          },
        }),
        axios.get(`${BASE_URL}/discharge/uploads/${transNo}/soa`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              "authentication/token"
            )}`,
          },
        }),
      ]);
      // Map API response to file state format
      const mapToFileState = (uploads) =>
        uploads.map((upload) => ({
          file: { name: upload.original_file_name }, // Fake file obj for display
          progress: 100,
          isUploading: false,
          uploadId: upload.upload_id,
          error: null,
          signed_url: upload.signed_url,
          originalFileName: upload.original_file_name, // Extra for display if needed
        }));
      setProofFiles(mapToFileState(proofRes.data));
      setSoaFiles(mapToFileState(soaRes.data));
      // Update form data with JSON arrays
      setProofFormData((prev) => ({
        ...prev,
        proof_guarantee_upload: JSON.stringify(
          proofRes.data.map((u) => ({
            uploadId: u.upload_id,
            signed_url: u.signed_url,
            file_name: u.original_file_name,
          }))
        ),
      }));
      setSoaFormData((prev) => ({
        ...prev,
        soa_fileupload: JSON.stringify(
          soaRes.data.map((u) => ({
            uploadId: u.upload_id,
            signed_url: u.signed_url,
            file_name: u.original_file_name,
          }))
        ),
      }));
    } catch (error) {
      console.error("Failed to fetch uploaded files:", error);
      toast.error("Failed to load uploaded files");
    }
  };
  const fetchClaimProcessingSyncData = async (transNo) => {
    try {
      setClaimSyncLoading(true);
      const response = await axios.get(
        `${BASE_URL}/admission-discharges/${transNo}/claim-processing-sync`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              "authentication/token"
            )}`,
          },
        }
      );
      setClaimSyncData(response.data?.data || null);
    } catch (error) {
      console.error("Failed to fetch Process Claim sync data:", error);
      setClaimSyncData(null);
    } finally {
      setClaimSyncLoading(false);
    }
  };
  const buildPhysicianSelectValue = (row) => {
    if (!row) return null;
    if (row.physician_option) return row.physician_option;

    const physicianName =
      String(row.physician || row.physician_name || row.label || "")
        .replace(/\s+/g, " ")
        .trim();

    if (!physicianName) return null;

    return {
      id: row.physician_id || physicianName,
      value: row.physician_id || physicianName,
      label: physicianName,
      full_name: physicianName,
      physician_id: row.physician_id || null,
      raw: row,
    };
  };
  const handleSyncFinalDiagnosis = () => {
    const option = claimSyncFinalDiagnosis?.option;
    if (!option) {
      toast.error(claimSyncFinalDiagnosis?.message || "No Process Claim ICD available to sync.");
      return;
    }

    setSelectedFinalIcd(option);
    setValue("final_diagnosis", option.label || "", {
      shouldDirty: true,
      shouldValidate: true,
    });
    trigger("final_diagnosis");
    toast.success("Final diagnosis synced from Process Claim.");
  };
  const handleSyncPhysicians = () => {
    if (!claimSyncPhysicians.length) {
      toast.error("No Process Claim physicians available to sync.");
      return;
    }

    const rows = claimSyncPhysicians.map((physician) => ({
      physician_id: physician.physician_id || physician.option?.physician_id || null,
      physician: physician.physician_name || physician.option?.label || "",
      physician_option: physician.option || null,
      role: physician.role || "",
      amount: toFiniteNumber(physician.amount, 0),
      philhealth: toFiniteNumber(physician.philhealth, 0),
    }));

    replacePhys(rows);
    setValue("physician_rows", rows, {
      shouldDirty: true,
      shouldValidate: true,
    });
    trigger("physician_rows");
    toast.success("Physicians synced from Process Claim.");
  };
  const handleSyncClaimRemarks = () => {
    if (!hasClaimSyncRemarks) {
      toast.error("No Process Claim remarks available to sync.");
      return;
    }

    setValue("claim_remarks", claimSyncRemarks, {
      shouldDirty: true,
      shouldValidate: true,
    });
    trigger("claim_remarks");
    toast.success("Uncovered item remarks synced from Process Claim remarks.");
  };
  const fetchDetails = async (transNo) => {
    try {
      setLoading(true);
      // const response = await axios.get(
      // `${BASE_URL}/admission-discharges/${transNo}/details`
      // );
      const response = await axios.get(
        `${BASE_URL}/admission-discharges/${transNo}/details`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              "authentication/token"
            )}`,
          },
        }
      );
      const data = response.data.data;
      setDetails(data);
      setValue("admission_date", data?.transaction?.admission_date || "");
      // setValue("initial_diagnosis", data?.transaction?.initial_icd || "");
      setValue("initial_diagnosis", data?.transaction?.initial_icd_2 || "");
      setValue("final_diagnosis", data?.transaction?.final_icd || ""); // Added for final
      setValue("hospital_name", data?.transaction?.provider_name || "");
      const loadedBenefits = normalizeDischargeBenefits(data?.benefits || {});
      setBenefits(loadedBenefits);
      // setMblRemainingLimit(data.remaining_limit || 0);
      setMblRemainingLimit(loadedBenefits?.remaining_ip_limit || 0);
      // Pre-populate sections if data exists
      // if (data.rnb_details) setValue("rnb_rows", JSON.parse(data.rnb_details));
      // rnb_rows: [
      // { room_type: "", room_no: "", rate: 0, days: 1, amount: 0, covered: 0 },
      // ],
      // "rnb1":"Ward","rnb_roomno1":"9696","rnb_rate1":"555.00","rnb_daysconfined1":"21","rnb_totalfee1":"6660.00",
      setValue("rnb_rows[0].room_type", data?.transaction?.rnb1);
      setValue("rnb_rows[0].room_no", data?.transaction?.rnb_roomno1);
      setValue("rnb_rows[0].rate", data?.transaction?.rnb_rate1);
      setValue("rnb_rows[0].days", data?.transaction?.rnb_daysconfined1);
      setValue("rnb_rows[0].amount", data?.transaction?.rnb_totalfee1);
      if (data.phys_details)
        setValue("physician_rows", JSON.parse(data.phys_details));
      // Similar for surgical, misc
      trigger("rnb_rows"); // Validate days match
    } catch (error) {
      toast.error("Failed to load discharge details");
    } finally {
      setLoading(false);
    }
  };
  const loadDropdownData = async () => {
    try {
      // const [physRes, miscRes] = await Promise.all([
      // axios.get(`${BASE_URL}/providers/${details?.provider_code}/physicians`),
      // axios.get(`${BASE_URL}/misc-services`),
      // // Removed ICD fetch - handled by async loadOptions now
      // ]);
      // setPhysicians(physRes.data);
      // setMiscServices(miscRes.data);
      const params = { limit: 20 };
      const response = await axios.get(`${BASE_URL}/discharge/miscellaneous`, {
        params,
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "authentication/token"
          )}`,
        },
      });
      setMiscServices(response?.data?.data || []);
      // Removed setIcdOptions
    } catch (error) {
      console.error("Failed to load dropdown data");
    }
  };
  // New: Shared loadIcdOptions matching sample (for both initial/final)
  const loadIcdOptions = useCallback(async (inputValue, callback) => {
    if (!inputValue || inputValue.length < 2) {
      callback([]);
      return;
    }
    try {
      const response = await axios.get(`${BASE_URL}/discharge/icds`, {
        params: { q: inputValue },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "authentication/token"
          )}`,
        },
      });
      if (response.data.status == "success") {
        callback(response.data.data);
      } else {
        callback([]);
      }
    } catch (error) {
      console.error("Failed to load ICDs:", error);
      callback([]);
    }
  }, []);
  // New: loadRuvOptions for Surgical Benefit - initial 20 on open, search on type (min 2 chars)
  const loadRuvOptions = useCallback(async (inputValue, callback) => {
    try {
      const params = { limit: 20 };
      if (inputValue && inputValue.length >= 2) {
        params.q = inputValue;
      } else if (!inputValue) {
        // Initial load: top 20 (e.g., by code or recent, backend handles)
      } else {
        callback([]);
        return;
      }
      const response = await axios.get(`${BASE_URL}/discharge/ruvs`, {
        params,
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "authentication/token"
          )}`,
        },
      });
      if (response.data.status == "success") {
        console.log(response.data);
        const options = response.data.data.map((ruv) => ({
          value: ruv.rvu_code,
          label: `${ruv.rvu_code} - ${ruv.rvu_description}`,
          rvu_code: ruv.rvu_code,
          ruv_unit: ruv.ruv_unit,
          rvu_description: ruv.rvu_description,
          // Optionally include value for display or computation: `${ruv.rvu_code} - ${ruv.rvu_description} (Value: ${ruv.value})`
        }));
        callback(options);
      } else {
        callback([]);
      }
    } catch (error) {
      console.error("Failed to load RVUs:", error);
      callback([]);
    }
  }, []);
  // New: Handlers for separate states
  const handleInitialIcdSelect = (selected) => {
    setSelectedInitialIcd(selected);
    setValue("initial_diagnosis", selected ? selected.label : "");
  };
  const handleFinalIcdSelect = (selected) => {
    setSelectedFinalIcd(selected);
    setValue("final_diagnosis", selected ? selected.label : "");
  };
  // New: Handler for RVU select per row (using field.id to separate instances)
  const handleRvuSelect = useCallback(
    (fieldId, selected) => {
      setSelectedRvus((prev) => ({ ...prev, [fieldId]: selected }));
      // Find index by fieldId to setValue
      const index = surgFields.findIndex((field) => field.id == fieldId);
      if (index !== -1) {
        setValue(
          `surgical_rows.${index}.ruv_description`,
          selected ? selected.label : ""
        );
        setValue(
          `surgical_rows.${index}.rvu_code`,
          selected ? selected.rvu_code : ""
        );
        // Optionally set ruv_unit if needed: setValue(`surgical_rows.${index}.ruv_unit`, selected ? selected.value_data || 1 : 0);
        const ruvUnit = selected ? selected.ruv_unit || 1 : 0;
        setValue(`surgical_rows.${index}.ruv_unit`, ruvUnit);
        // Compute amount if not manual
        const rnbType = watch(`surgical_rows.${index}.rnb_type`) || "Ward";
        const rmAmt = Number(
          RNB_OPTIONS.find((item) => item.value === rnbType)?.rm_amt || 120
        );
        const computedAmount = ruvUnit * rmAmt;
        if (!manualAmounts[fieldId]) {
          setValue(`surgical_rows.${index}.amount`, computedAmount.toFixed(2));
        }
      }
    },
    [surgFields, setValue, watch, manualAmounts]
  );
  // Updated handleRnbChange to respect manual amounts
  const handleRnbChange = (e, index) => {
    const selected = e.target.options[e.target.selectedIndex];
    const seq = selected.getAttribute("data-seq");
    const rmAmt = parseFloat(selected.getAttribute("data-rm_amt")) || 0;
    const ipRate = parseFloat(selected.getAttribute("data-ip_rate")) || 0;
    console.log("Row index:", index);
    console.log({ seq, rmAmt, ipRate });
    // Get RUV unit (string → number)
    const ruv_unit = parseFloat(watch(`surgical_rows.${index}.ruv_unit`) || 0);
    console.log("RUV =", ruv_unit);
    // Compute
    const computedAmount = rmAmt * ruv_unit;
    console.log("Computed Amount =", computedAmount);
    // Check if manual
    const fieldId = surgFields[index].id;
    if (!manualAmounts[fieldId]) {
      // Save to the row's amount field only if not manual
      setValue(`surgical_rows.${index}.amount`, computedAmount.toFixed(2));
    }
  };
  const handleAddMisc = () => {
    appendMisc({ particulars: "", amount: 0 });
  };
  // Function to calculate totals for misc
  const miscTotalAmount = miscFields.reduce(
    (sum, field) => sum + toFiniteNumber(watch(`misc_rows.${field.index}.amount`), 0),
    0
  );
  const miscTotalPhilhealth = toFiniteNumber(watch("misc_rows_philhealth"), 0);
  // Proof of Guarantee Upload Handlers
  const allowedFileTypes = ["pdf", "jpg", "jpeg", "png"];
  const uploadFileSizeLimitMB = 80;
  const uploadFileSizeLimitLabel = "80MB";
  const maxUploadLimit = 5;
  const getUploadErrorMessage = (error, file) => {
    const response = error?.response;
    const responseData = response?.data;
    const fileErrors = responseData?.errors?.file;
    const fileName = file?.name || "Selected file";
    const isSelectedFileOverCurrentLimit =
      Number(file?.size || 0) > uploadFileSizeLimitMB * 1024 * 1024;
    const serverMessages = [
      ...(Array.isArray(fileErrors) ? fileErrors : fileErrors ? [fileErrors] : []),
      responseData?.message,
      responseData?.error,
      typeof responseData === "string" ? responseData : "",
      error?.message,
    ]
      .filter(Boolean)
      .map(String);

    const sizeLimitMessage = serverMessages.find((message) =>
      /(size|large|greater|exceed|max|kilobytes|payload|post)/i.test(message)
    );

    if (response?.status === 413 || sizeLimitMessage) {
      const kilobyteMatch = sizeLimitMessage?.match(/(\d+(?:\.\d+)?)\s*kilobytes?/i);
      const sizeLimitLabel = kilobyteMatch
        ? `${Number(kilobyteMatch[1]) / 1024}MB`
        : uploadFileSizeLimitLabel;

      return `File ${fileName} exceeds the allowed file size (${sizeLimitLabel}).`;
    }

    if (response?.status === 422 && isSelectedFileOverCurrentLimit) {
      return `File ${fileName} exceeds the allowed file size (${uploadFileSizeLimitLabel}).`;
    }

    return serverMessages[0] || "Failed to upload file.";
  };
  const handleDragOverProof = (e) => {
    e.preventDefault();
    setIsDraggingProof(true);
  };
  const handleDragLeaveProof = (e) => {
    e.preventDefault();
    setIsDraggingProof(false);
  };
  const handleDropProof = (e) => {
    e.preventDefault();
    setIsDraggingProof(false);
    handleProofFileChange(Array.from(e.dataTransfer.files));
  };
  const handleChooseProofFile = () => {
    proofFileInputRef.current?.click();
  };
  const handleProofFileChange = (selectedFiles) => {
    const validFiles = Array.from(selectedFiles).filter((file) => {
      console.log("test123");
      console.log(file.name);
      const fileExtension = file.name?.split(".").pop().toLowerCase();
      const isAllowedType = allowedFileTypes.includes(fileExtension);
      if (!isAllowedType) {
        toast.error(
          `File ${file.name} is not supported. Only ${allowedFileTypes.join(
            ", "
          )} files allowed.`,
          { duration: 4000 }
        );
        return false;
      }
      return true;
    });
    if (proofFiles.length + validFiles.length > maxUploadLimit) {
      toast.error(
        `You can only upload up to ${maxUploadLimit} files at a time.`,
        { duration: 4000 }
      );
      return;
    }
    const newFiles = validFiles.map((file) => ({
      file,
      progress: 0,
      isUploading: false,
      uploadId: null,
      error: null,
      signed_url: null,
    }));
    setProofFiles((prevFiles) => [...prevFiles, ...newFiles]);
    newFiles.forEach((fileObj) => handleProofFileUpload(fileObj));
  };
  const handleProofFileUpload = async (fileObj) => {
    setProofFiles((prevFiles) =>
      prevFiles.map((f) =>
        f.file == fileObj.file ? { ...f, isUploading: true } : f
      )
    );
    try {
      const proofFormDataUpload = new FormData();
      proofFormDataUpload.append("file", fileObj.file);
      proofFormDataUpload.append("trans_no", transNo);
      const response = await axios.post(
        `${BASE_URL}/discharge/upload-proof`,
        proofFormDataUpload,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              "authentication/token"
            )}`,
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            const progress = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setProofFiles((prevFiles) =>
              prevFiles.map((f) =>
                f.file == fileObj.file ? { ...f, progress } : f
              )
            );
          },
        }
      );
      const { upload_id, signed_url, file_name } = response.data;
      setProofFiles((prevFiles) =>
        prevFiles.map((f) =>
          f.file == fileObj.file
            ? {
                ...f,
                isUploading: false,
                progress: 100,
                uploadId: upload_id,
                signed_url,
              }
            : f
        )
      );
      setProofFormData((prev) => ({
        ...prev,
        proof_guarantee_upload: JSON.stringify([
          ...JSON.parse(prev.proof_guarantee_upload || "[]"),
          { uploadId: upload_id, signed_url, file_name },
        ]),
      }));
      toast.success(`File ${fileObj.file.name} uploaded successfully!`, {
        duration: 4000,
      });
    } catch (error) {
      const errorMessage = getUploadErrorMessage(error, fileObj.file);
      setProofFiles((prevFiles) =>
        prevFiles.map((f) =>
          f.file == fileObj.file
            ? { ...f, isUploading: false, error: errorMessage }
            : f
        )
      );
      toast.error(errorMessage, { duration: 4000 });
    }
  };
  const handleViewProofFile = (fileObj) => {
    if (fileObj.signed_url) {
      window.open(fileObj.signed_url, "_blank");
    }
  };
  const handleRemoveProofFile = (fileObj) => {
    if (fileObj.uploadId) {
      // Call delete API
      axios
        .delete(`${BASE_URL}/discharge/upload/${fileObj.uploadId}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              "authentication/token"
            )}`,
          },
        })
        .then(() => {
          toast.success("File removed successfully");
        })
        .catch(() => {
          toast.error("Failed to remove file");
        });
    }
    setProofFiles((prev) => prev.filter((f) => f !== fileObj));
    setProofFormData((prev) => ({
      ...prev,
      proof_guarantee_upload: JSON.stringify(
        JSON.parse(prev.proof_guarantee_upload || "[]").filter(
          (f) => f.uploadId !== fileObj.uploadId
        )
      ),
    }));
  };
  // SOA Upload Handlers (similar to proof)
  const handleDragOverSoa = (e) => {
    e.preventDefault();
    setIsDraggingSoa(true);
  };
  const handleDragLeaveSoa = (e) => {
    e.preventDefault();
    setIsDraggingSoa(false);
  };
  const handleDropSoa = (e) => {
    e.preventDefault();
    setIsDraggingSoa(false);
    handleSoaFileChange(Array.from(e.dataTransfer.files));
  };
  const handleChooseSoaFile = () => {
    soaFileInputRef.current?.click();
  };
  const handleSoaFileChange = (selectedFiles) => {
    const validFiles = Array.from(selectedFiles).filter((file) => {
      console.log("test123");
      console.log(file.name);
      const fileExtension = file.name?.split(".").pop().toLowerCase();
      const isAllowedType = allowedFileTypes.includes(fileExtension);
      if (!isAllowedType) {
        toast.error(
          `File ${file.name} is not supported. Only ${allowedFileTypes.join(
            ", "
          )} files allowed.`,
          { duration: 4000 }
        );
        return false;
      }
      return true;
    });
    if (soaFiles.length + validFiles.length > maxUploadLimit) {
      toast.error(
        `You can only upload up to ${maxUploadLimit} fields at a time.`,
        { duration: 4000 }
      );
      return;
    }
    const newFiles = validFiles.map((file) => ({
      file,
      progress: 0,
      isUploading: false,
      uploadId: null,
      error: null,
      signed_url: null,
    }));
    setSoaFiles((prevFiles) => [...prevFiles, ...newFiles]);
    newFiles.forEach((fileObj) => handleSoaFileUpload(fileObj));
  };
  const handleSoaFileUpload = async (fileObj) => {
    setSoaFiles((prevFiles) =>
      prevFiles.map((f) =>
        f.file == fileObj.file ? { ...f, isUploading: true } : f
      )
    );
    try {
      const soaFileformData = new FormData();
      soaFileformData.append("file", fileObj.file);
      soaFileformData.append("trans_no", transNo);
      const response = await axios.post(
        `${BASE_URL}/discharge/upload-soa`,
        soaFileformData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              "authentication/token"
            )}`,
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            const progress = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setSoaFiles((prevFiles) =>
              prevFiles.map((f) =>
                f.file == fileObj.file ? { ...f, progress } : f
              )
            );
          },
        }
      );
      const { upload_id, signed_url, file_name } = response.data;
      setSoaFiles((prevFiles) =>
        prevFiles.map((f) =>
          f.file == fileObj.file
            ? {
                ...f,
                isUploading: false,
                progress: 100,
                uploadId: upload_id,
                signed_url,
              }
            : f
        )
      );
      setSoaFormData((prev) => ({
        ...prev,
        soa_fileupload: JSON.stringify([
          ...JSON.parse(prev.soa_fileupload || "[]"),
          { uploadId: upload_id, signed_url, file_name },
        ]),
      }));
      toast.success(`File ${fileObj.file.name} uploaded successfully!`, {
        duration: 4000,
      });
    } catch (error) {
      const errorMessage = getUploadErrorMessage(error, fileObj.file);
      setSoaFiles((prevFiles) =>
        prevFiles.map((f) =>
          f.file == fileObj.file
            ? { ...f, isUploading: false, error: errorMessage }
            : f
        )
      );
      toast.error(errorMessage, { duration: 4000 });
    }
  };
  const handleViewSoaFile = (fileObj) => {
    if (fileObj.signed_url) {
      window.open(fileObj.signed_url, "_blank");
    }
  };
  const handleRemoveSoaFile = (fileObj) => {
    if (fileObj.uploadId) {
      // Call delete API
      axios
        .delete(`${BASE_URL}/discharge/upload/${fileObj.uploadId}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              "authentication/token"
            )}`,
          },
        })
        .then(() => {
          toast.success("File removed successfully");
        })
        .catch(() => {
          toast.error("Failed to remove file");
        });
    }
    setSoaFiles((prev) => prev.filter((f) => f !== fileObj));
    setSoaFormData((prev) => ({
      ...prev,
      soa_fileupload: JSON.stringify(
        JSON.parse(prev.soa_fileupload || "[]").filter(
          (f) => f.uploadId !== fileObj.uploadId
        )
      ),
    }));
  };

  // showDelay into your form context
  useEffect(() => {
    setValue("is_delay", showDelay); // hidden field for yup
  }, [showDelay]);

  // UseEffect (Always detects PH Time + computes difference)
  useEffect(() => {
    const interval = setInterval(() => {
      const soaDate = watch("soa_received_date"); // value from react-hook-form
      if (!soaDate) return;

      // Convert soa_received_date to JS date
      const soaDateObj = new Date(soaDate);

      // Get current PH time
      const now = new Date(
        new Date().toLocaleString("en-US", { timeZone: "Asia/Manila" })
      );

      // Compute difference in minutes
      const diffMs = now - soaDateObj;
      const diffMins = diffMs / 1000 / 60;

      // If delay is more than 30 mins
      if (diffMins > 30) {
        console.log("SOA Received delay: More than 30 minutes!");
        setShowDelay(true);
      } else {
        console.log("SOA Received delay: NOT More than 30 minutes!");
        setShowDelay(false);
      }
      // }, 15000); // runs every 15 seconds
    }, 5000); // runs every 5 seconds

    return () => clearInterval(interval);
  }, [watch("soa_received_date")]);

  const summaryBenefitRows = benefitSummaryRows.map((row) => ({
    ...row,
    values: summaryData?.benefit_summary?.[row.key] || {},
  }));
  const rawSummaryBenefitTotals = summaryBenefitRows.reduce((acc, row) => {
    const values = row.values || {};
    acc.incurred += toFiniteNumber(values.incurred, 0);
    acc.philhealth += toFiniteNumber(values.philhealth, 0);
    acc.covered +=
      toFiniteNumber(values.basicCovered, 0) +
      toFiniteNumber(values.majorCovered, 0);
    acc.excess += toFiniteNumber(values.excess, 0);
    return acc;
  }, {
    incurred: 0,
    philhealth: 0,
    covered: 0,
    excess: 0,
    uncovered: toFiniteNumber(summaryData?.benefit_totals?.uncovered, 0),
  });
  const getBenefitTotal = (key, fallback) =>
    typeof summaryData?.benefit_totals?.[key] === "undefined"
      ? fallback
      : toFiniteNumber(summaryData.benefit_totals[key], fallback);
  const summaryBenefitTotals = {
    ...rawSummaryBenefitTotals,
    incurred: getBenefitTotal("incurred", rawSummaryBenefitTotals.incurred),
    philhealth: getBenefitTotal("philhealth", rawSummaryBenefitTotals.philhealth),
    covered: getBenefitTotal("covered", rawSummaryBenefitTotals.covered),
    excess: getBenefitTotal("excess", rawSummaryBenefitTotals.excess),
  };

  if (loading) {
    return (
      <LoadingScreen
        title="Loading Confinement details..."
        subtitle="Please wait a moment"
      />
    );
  }
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="space-y-6 p-4 bg-white rounded-xl shadow-sm border border-gray-200 max-h-[calc(100vh-150px)] overflow-auto"
    >
      {/* Header */}
      <div className="flex items-center space-x-3 mb-3">
        <FontAwesomeIcon
          icon={faHospital}
          className="text-xl text-indigo-500"
        />
        <h2 className="text-xl font-semibold text-gray-900">
          Confinement Information
        </h2>
        <div className="ml-auto">
          <span className="text-xs text-gray-500">
            Transaction #: {transNo}
          </span>
        </div>
      </div>
      <form onSubmit={handleSubmit(onSubmit, onError)} className="space-y-6">
        <input type="hidden" {...register("is_delay")} />

        {/* Basic Info */}
        <div className="space-y-3 rounded-lg border border-gray-200 bg-gray-50 p-4 shadow-sm">
          <h5 className="flex items-center space-x-2 text-xs font-semibold text-gray-900">
            <FontAwesomeIcon icon={faInfoCircle} className="text-indigo-500" />
            <span>Basic Information</span>
          </h5>
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
            <div className="space-y-1">
              <label className="flex items-center space-x-1 text-xs text-gray-600">
                <FontAwesomeIcon
                  icon={faHospital}
                  className="text-indigo-400"
                  size="sm"
                />
                <span>Hospital Name</span>
              </label>
              <input
                {...register("hospital_name")}
                disabled
                className="w-full rounded-md border border-gray-300 px-3 py-1 text-sm disabled:bg-gray-100"
                // value={details?.transaction?.provider_name || "N/A"}
              />
            </div>
            <div className="space-y-1">
              <label className="flex items-center space-x-1 text-xs text-gray-600">
                <FontAwesomeIcon
                  icon={faCalendar}
                  className="text-indigo-400"
                  size="sm"
                />
                <span>Admission Date</span>
              </label>
              <input
                type="datetime-local"
                step="1"
                {...register("admission_date")}
                className="w-full rounded-md border border-gray-300 px-3 py-1 text-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
              />
              {errors.admission_date && (
                <p className="text-xs text-red-500">
                  {errors.admission_date.message}
                </p>
              )}
            </div>
            <div className="space-y-1">
              <label className="flex items-center space-x-1 text-xs text-gray-600">
                <FontAwesomeIcon
                  icon={faCalendar}
                  className="text-indigo-400"
                  size="sm"
                />
                <span>Discharge Date</span>
              </label>
              <input
                type="datetime-local"
                step="1"
                {...register("discharged_date")}
                className="w-full rounded-md border border-gray-300 px-3 py-1 text-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
              />
              {errors.discharged_date && (
                <p className="text-xs text-red-500">
                  {errors.discharged_date.message}
                </p>
              )}
            </div>
            <div className="md:col-span-3 space-y-1">
              <label className="flex items-center space-x-1 text-xs text-gray-600">
                <FontAwesomeIcon
                  icon={faBed}
                  className="text-indigo-400"
                  size="sm"
                />
                <span>No. of Days Confined</span>
              </label>
              <input
                type="number" step="any"
                disabled
                value={calculateDaysConfined()}
                className="w-full rounded-md border border-gray-300 px-3 py-1 text-sm disabled:bg-gray-100"
              />
            </div>
          </div>
        </div>
        {/* SOA Received - Modernized */}
        <div className="space-y-3 rounded-lg border border-gray-200 bg-blue-50 p-4 shadow-sm">
          <h5 className="flex items-center space-x-2 text-xs font-semibold text-gray-900">
            <FontAwesomeIcon icon={faClock} className="text-blue-500" />
            <span>Date & Time Final SOA Received *</span>
          </h5>
          <div className="grid grid-cols-1 gap-4 md:grid-cols-3 items-end">
            <div className="space-y-1">
              <label className="flex items-center space-x-1 text-xs text-gray-600">
                <FontAwesomeIcon
                  icon={faCalendar}
                  className="text-blue-400"
                  size="sm"
                />
                <span>Date</span>
              </label>
              <input
                type="datetime-local"
                step="1"
                {...register("soa_received_date")}
                className="w-full rounded-md border border-gray-300 px-3 py-1 text-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
              />
              {errors.soa_received_date && (
                <p className="text-xs text-red-500">
                  {errors.soa_received_date.message}
                </p>
              )}
            </div>
          </div>
        </div>
        {/* Delay Section - Conditional */}
        <AnimatePresence>
          {showDelay && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: "auto" }}
              exit={{ opacity: 0, height: 0 }}
              className="space-y-3 rounded-lg border border-red-200 bg-red-50 p-4 shadow-sm"
            >
              <h5 className="flex items-center space-x-2 text-xs font-semibold text-red-800">
                <FontAwesomeIcon
                  icon={faExclamationTriangle}
                  className="text-red-500"
                />
                <span>Delay Information</span>
              </h5>
              <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
                <div className="space-y-1">
                  <label className="flex items-center space-x-1 text-xs text-gray-600">
                    <FontAwesomeIcon
                      icon={faUserMd}
                      className="text-red-400"
                      size="sm"
                    />
                    <span>Responsible for Delay *</span>
                  </label>
                  <select
                    {...register("delay_responsible")}
                    onChange={(e) => {
                      setValue("delay_responsible", e.target.value);
                      setDelayResponsible(e.target.value);
                    }}
                    className="w-full min-w-0 truncate rounded-md border border-gray-300 px-3 py-1 text-sm focus:border-red-500 focus:outline-none focus:ring-1 focus:ring-red-500"
                  >
                    <option value="">Select</option>
                    <option value="Processor">Processor</option>
                    <option value="System">System</option>
                    <option value="Corporate">Corporate</option>
                    <option value="Provider">Provider</option>
                  </select>
                  {errors.delay_responsible && (
                    <p className="text-xs text-red-500">
                      {errors.delay_responsible.message}
                    </p>
                  )}
                </div>
                <div className="space-y-1">
                  <label className="flex items-center space-x-1 text-xs text-gray-600">
                    <FontAwesomeIcon
                      icon={faExclamationTriangle}
                      className="text-red-400"
                      size="sm"
                    />
                    <span>Reason for Delay *</span>
                  </label>
                  <select
                    {...register("delay_reason")}
                    className="w-full min-w-0 truncate rounded-md border border-gray-300 px-3 py-1 text-sm focus:border-red-500 focus:outline-none focus:ring-1 focus:ring-red-500"
                  >
                    {/* Dynamic options based on responsible */}
                    {delayResponsible == "Processor" && (
                      <>
                        <option value="">Select</option>
                        <option value="New Processor">New Processor</option>
                        <option value="Late Handle">Late Handle</option>
                        <option value="Segregation of Charges">
                          Segregation of Charges
                        </option>
                        <option value="Others">Others, please specify:</option>
                      </>
                    )}
                    {/* Similar for other responsibles */}
                    {/* Dynamic options based on responsible */}
                    {delayResponsible == "System" && (
                      <>
                        <option value="">Select</option>
                        <option value="New Processor">New Processor</option>
                        <option value="Late Handle">Late Handle</option>
                        <option value="Segregation of Charges">
                          Segregation of Charges
                        </option>
                        <option value="Others">Others, please specify:</option>
                      </>
                    )}
                    {/* Dynamic options based on responsible */}
                    {delayResponsible == "Corporate" && (
                      <>
                        <option value="">Select</option>
                        <option value="New Processor">New Processor</option>
                        <option value="Late Handle">Late Handle</option>
                        <option value="Segregation of Charges">
                          Segregation of Charges
                        </option>
                        <option value="Others">Others, please specify:</option>
                      </>
                    )}
                    {/* Dynamic options based on responsible */}
                    {delayResponsible == "Provider" && (
                      <>
                        <option value="">Select</option>
                        <option value="New Processor">New Processor</option>
                        <option value="Late Handle">Late Handle</option>
                        <option value="Segregation of Charges">
                          Segregation of Charges
                        </option>
                        <option value="Others">Others, please specify:</option>
                      </>
                    )}
                  </select>
                  {errors.delay_reason && (
                    <p className="text-xs text-red-500">
                      {errors.delay_reason.message}
                    </p>
                  )}
                </div>
                {watch("delay_reason") == "Others" && (
                  <div className="md:col-span-3 space-y-1">
                    <label className="flex items-center space-x-1 text-xs text-gray-600">
                      <FontAwesomeIcon
                        icon={faInfoCircle}
                        className="text-red-400"
                        size="sm"
                      />
                      <span>Others *</span>
                    </label>
                    <textarea
                      {...register("delay_other")}
                      className="w-full rounded-md border border-gray-300 px-3 py-1 text-sm focus:border-red-500 focus:outline-none focus:ring-1 focus:ring-red-500"
                      placeholder="Other reason for delay"
                      rows={2}
                    />
                    {errors.delay_other && (
                      <p className="text-xs text-red-500">
                        {errors.delay_other.message}
                      </p>
                    )}
                  </div>
                )}
              </div>
            </motion.div>
          )}
        </AnimatePresence>

        {/* Updated Diagnosis Section - Matching sample */}
        <div className="space-y-3 rounded-lg border border-gray-200 bg-gray-50 p-4 shadow-sm">
          <h5 className="flex items-center space-x-2 text-xs font-semibold text-gray-900">
            <FontAwesomeIcon icon={faFileMedical} className="text-indigo-500" />
            <span>Diagnosis</span>
          </h5>
          <div className="grid grid-cols-1 gap-4 md:grid-cols-3 lg:grid-cols-3">
            <div className="space-y-1">
              <label className="flex items-center space-x-1 text-xs text-gray-600">
                <FontAwesomeIcon
                  icon={faFilter}
                  className="text-indigo-400"
                  size="sm"
                />
                <span>(ICD Codes) Initial Diagnosis *</span>
              </label>
              <Select
                cacheOptions
                defaultOptions // Load initial on focus
                loadOptions={loadIcdOptions}
                value={selectedInitialIcd}
                onChange={handleInitialIcdSelect}
                placeholder="Type to search ICD (min 2 chars)..."
                loadingMessage={() => "Searching ICDs..."}
                noOptionsMessage={() => "Type to search ICDs"}
                menuPortalTarget={
                  typeof document !== "undefined" ? document.body : null
                }
                menuPosition="fixed"
                styles={compactSelectStyles}
                formatOptionLabel={formatCompactSelectLabel}
                className="text-xs"
                debounceTimeout={300}
              />
              {errors.initial_diagnosis && (
                <p className="text-xs text-red-500">
                  {errors.initial_diagnosis.message}
                </p>
              )}
            </div>
            <div className="space-y-1">
              <div className="flex items-center justify-between gap-2">
                <label className="flex items-center space-x-1 text-xs text-gray-600">
                  <FontAwesomeIcon
                    icon={faFilter}
                    className="text-indigo-400"
                    size="sm"
                  />
                  <span>(ICD Codes) Final Diagnosis *</span>
                </label>
                {hasClaimSyncFinalDiagnosis && (
                  <button
                    type="button"
                    onClick={handleSyncFinalDiagnosis}
                    disabled={claimSyncLoading}
                    title="Sync Final Diagnosis from Process Claim"
                    className="inline-flex items-center gap-1 rounded border border-indigo-200 bg-white px-2 py-1 text-[11px] font-medium text-indigo-700 hover:bg-indigo-50 disabled:opacity-50"
                  >
                    <FontAwesomeIcon
                      icon={claimSyncLoading ? faSpinner : faRefresh}
                      spin={claimSyncLoading}
                    />
                    <span>Sync</span>
                  </button>
                )}
              </div>
              <div className="flex items-start space-x-3">
                <div className="flex-1">
                  <Select
                    cacheOptions
                    defaultOptions // Load initial on focus
                    loadOptions={loadIcdOptions}
                    value={selectedFinalIcd}
                    onChange={handleFinalIcdSelect}
                    placeholder="Type to search ICD (min 2 chars)..."
                    loadingMessage={() => "Searching ICDs..."}
                    noOptionsMessage={() => "Type to search ICDs"}
                    menuPortalTarget={
                      typeof document !== "undefined" ? document.body : null
                    }
                    menuPosition="fixed"
                    styles={compactSelectStyles}
                    formatOptionLabel={formatCompactSelectLabel}
                    className="text-xs"
                    debounceTimeout={300}
                  />
                </div>
              </div>
              {errors.final_diagnosis && (
                <p className="text-xs text-red-500">
                  {errors.final_diagnosis.message}
                </p>
              )}
            </div>

            {ENABLE_AI_ICD_SEARCH && (
              <div className="space-y-1">
                <button
                  type="button"
                  onClick={() => openAiChat()}
                  className="relative flex items-center space-x-3 px-4 py-2 bg-indigo-50 border border-indigo-200 rounded-md text-sm hover:bg-indigo-100 focus:outline-none"
                >
                  {/* subtle rotating blurred ring behind button */}
                  <motion.div
                    aria-hidden
                    className="absolute -inset-1 rounded-md pointer-events-none"
                    // animate={{ rotate: 360 }}
                    transition={{ repeat: Infinity, duration: 8, ease: "linear" }}
                    style={{
                      background:
                        "conic-gradient(from 0deg, rgba(99,102,241,0.18), rgba(59,130,246,0.08), rgba(139,92,246,0.08))",
                      filter: "blur(6px)",
                      zIndex: 0,
                    }}
                  />

                  <div className="relative z-10 flex items-center space-x-3">
                    <motion.div
                      whileHover={{ scale: 1.12 }}
                      whileTap={{ scale: 0.98 }}
                      className="relative"
                    >
                      <FontAwesomeIcon
                        icon={faBrain}
                        className="text-lg text-indigo-600"
                      />
                      <motion.div
                        className="absolute -top-1 -right-2 w-2 h-2 bg-cyan-300 rounded-full"
                        animate={{ scale: [1, 1.6, 1] }}
                        transition={{ duration: 1, repeat: Infinity }}
                      />
                      <motion.div
                        className="absolute -bottom-1 -left-2 w-2 h-2 bg-purple-300 rounded-full"
                        animate={{ scale: [1, 1.4, 1] }}
                        transition={{ duration: 1, repeat: Infinity, delay: 0.5 }}
                      />
                    </motion.div>

                    <motion.span
                      key="analyze"
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      className="font-semibold text-sm text-indigo-700"
                    >
                      Search ICD Code Using AI
                    </motion.span>
                  </div>

                </button>
              </div>
            )}

            <div className="md:col-span-3 space-y-1">
              <label className="flex items-center space-x-1 text-xs text-gray-600">
                <FontAwesomeIcon
                  icon={faMoneyBillWave}
                  className="text-indigo-400"
                  size="sm"
                />
                <span>Remaining Limit for Selected ICD</span>
              </label>
              <div className="flex">
                <input
                  type="text"
                  value={formatBenefitValue(mblRemainingLimit)}
                  disabled
                  className="flex-1 rounded-l-md border border-gray-300 px-3 py-1 text-sm disabled:bg-gray-100"
                />
                <button
                  type="button"
                  className="px-3 py-1 bg-gray-300 rounded-r-md text-sm hover:bg-gray-400"
                  onClick={() =>
                    // alert(
                    //   "Zoom to full MBL remaining limit details - Placeholder functionality"
                    // )
                    alert(
                      `Zoom to full MBL remaining limit details:` +
                        details.benefits?.ip_max_limit
                    )
                  }
                >
                  Zoom
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Room & Board - Disabled if editingDisabled */}
        <motion.section
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={`space-y-3 rounded-lg border ${
            editingDisabled
              ? "border-gray-200 bg-gray-100 opacity-60"
              : "border-green-200 bg-green-50"
          } p-4 shadow-sm`}
        >
          <div className="flex flex-wrap items-center justify-between gap-2">
            <h5 className="flex items-center space-x-2 text-xs font-semibold text-gray-900">
              <FontAwesomeIcon icon={faBed} className="text-green-500" />
              <span>(RNB) Room & Board Benefit</span>
            </h5>
            {!editingDisabled && (
              <button
                type="button"
                onClick={() =>
                  appendRnb({
                    room_type: "",
                    room_no: "",
                    rate: 0,
                    days: 1,
                    amount: 0,
                    covered: 0,
                  })
                }
                className="flex items-center space-x-1 px-4 py-1 bg-green-600 text-white rounded text-md hover:bg-green-700 disabled:opacity-50"
              >
                <FontAwesomeIcon icon={faPlus} />
                <span>Add R&B</span>
              </button>
            )}
          </div>
          
          {editingDisabled && (
            <p className="text-xs text-yellow-700">
              Editing disabled due to PhilHealth settings.
            </p>
          )}
          <div className="overflow-auto">
            <table className="w-full min-w-[54rem] table-fixed border-collapse border border-gray-300">
              <thead>
                <tr className="bg-gray-100">
                  <th className={`${thBase} w-[12rem]`}>Room Type</th>
                  <th className={`${thBase} w-[8rem]`}>Room #</th>
                  <th className={`${thBase} w-[8rem]`}>Room Rate</th>
                  <th className={`${thBase} w-[8rem]`}>Days Confined</th>
                  <th className={`${thBase} w-[8rem]`}>Amount</th>
                  <th className={`${thBase} w-[8rem]`}>Covered</th>
                  <th className={`${thBase} w-[4rem]`}></th>
                </tr>
              </thead>
              <tbody>
                {rnbFields.map((field, index) => (
                  <tr
                    key={field.id}
                    className={editingDisabled ? "opacity-50" : ""}
                  >
                    <td className={tdBase}>
                      <select
                        {...register(`rnb_rows.${index}.room_type`)}
                        className={`w-full min-w-0 truncate border p-2 rounded text-sm ${
                          editingDisabled ? "bg-gray-100 text-gray-500" : ""
                        }`}
                        style={{
                          pointerEvents: editingDisabled ? "none" : "auto",
                        }}
                        tabIndex={editingDisabled ? -1 : 0}
                      >
                        <option value="">Select</option>
                        <option value="Ward">Ward</option>
                        <option value="Semi-Private">Semi-Private</option>
                        <option value="Private">Private</option>
                        <option value="Small Private">Small Private</option>
                        <option value="Regular Private">Regular Private</option>
                        <option value="Large Private">Large Private</option>
                        <option value="Suite">Suite</option>
                        <option value="ICU">ICU</option>
                      </select>
                    </td>
                    <td className={tdBase}>
                      <input
                        type="text"
                        {...register(`rnb_rows.${index}.room_no`)}
                        className={`${inputBase} ${
                          editingDisabled ? "bg-gray-100 text-gray-500" : ""
                        }`}
                        readOnly={editingDisabled}
                      />
                    </td>
                    <td className={tdBase}>
                      <input
                        type="number" step="any"
                        {...register(`rnb_rows.${index}.rate`)}
                        className={`${inputBase} ${
                          editingDisabled ? "bg-gray-100 text-gray-500" : ""
                        }`}
                        readOnly={editingDisabled}
                        onChange={(e) => {
                          setValue(
                            `rnb_rows.${index}.amount`,
                            Number(e.target.value) *
                              (watch(`rnb_rows.${index}.days`) || 0)
                          );
                        }}
                      />
                    </td>
                    <td className={tdBase}>
                      {(() => {
                        const daysField = register(`rnb_rows.${index}.days`);
                        const {
                          ref,
                          onChange: daysOnChange,
                          ...daysRest
                        } = daysField;
                        return (
                          <input
                            type="number" step="any"
                            min={1}
                            {...daysRest}
                            ref={ref}
                            className={`${inputBase} ${
                              editingDisabled ? "bg-gray-100 text-gray-500" : ""
                            }`}
                            readOnly={editingDisabled}
                            onChange={(e) => {
                              // first call RHF's onChange to update form state
                              daysOnChange && daysOnChange(e);
                              // update computed amount for this row
                              setValue(
                                `rnb_rows.${index}.amount`,
                                (watch(`rnb_rows.${index}.rate`) || 0) *
                                  Number(e.target.value || 0)
                              );
                              // do NOT call matchTotalDaysConfine here; effect using useWatch will run
                            }}
                          />
                        );
                      })()}
                    </td>
                    <td className={tdBase}>
                      <input
                        type="number" step="any"
                        readOnly
                        value={watch(`rnb_rows.${index}.amount`)}
                        className={disabledInput}
                      />
                    </td>
                    <td className={tdBase}>
                      {(() => {
                        const coveredField = register(
                          `rnb_rows.${index}.covered`
                        );
                        const {
                          ref: coveredRef,
                          onChange: coveredOnChange,
                          ...coveredRest
                        } = coveredField;
                        return (
                          <input
                            type="number" step="any"
                            {...coveredRest}
                            ref={coveredRef}
                            className={`${inputBase} ${
                              editingDisabled ? "bg-gray-100 text-gray-500" : ""
                            }`}
                            readOnly={editingDisabled}
                            onChange={(e) => {
                              coveredOnChange && coveredOnChange(e);
                              // manual edit: do not modify last-amount here so manual value persists
                            }}
                          />
                        );
                      })()}
                    </td>
                    <td className={tdBase}>
                      {!editingDisabled && (
                        <button
                          type="button"
                          onClick={() => {
                            const idToRemove = field.id;
                            removeRnb(index);
                            setRnbLastAmt((p) => {
                              const copy = { ...p };
                              delete copy[idToRemove];
                              return copy;
                            });
                          }}
                          className="text-red-500 hover:text-red-700 text-xs"
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
            <div className="space-y-1">
              <label className="block text-xs font-medium text-gray-700 text-right">
                Total PhilHealth
              </label>
              <input
                // type="number"
                // className={disabledInput + " text-right"}
                // value={rnbFields.reduce(
                // (sum, _, i) => sum + (watch(`rnb_rows.${i}.philhealth`) || 0),
                // 0
                // )}
                // disabled
                type="number" step="any"
                {...register(`rnb_rows_philhealth`)}
                className={`text-right ${inputBase} ${
                  editingDisabled ? "bg-gray-100 text-gray-500" : ""
                }`}
                readOnly={editingDisabled}
                // onChange={(e) => {
                // setValue(
                // `rnb_rows.${index}.amount`,
                // parseFloat(e.target.value) *
                // (watch(`rnb_rows.${index}.days`) || 0)
                // );
                // }}
              />
            </div>
            <div className="space-y-1">
              <label className="block text-xs font-medium text-gray-700 text-right">
                Total R&B
              </label>
              <input
                type="number" step="any"
                className={disabledInput + " text-right"}
                value={rnbFields.reduce(
                  (sum, _, i) =>
                    sum + toFiniteNumber(watch(`rnb_rows.${i}.amount`), 0),
                  0
                )}
                readOnly
              />
            </div>
            <div className="space-y-1">
              <label className="block text-xs font-medium text-gray-700 text-right">
                Total Covered
              </label>
              <input
                type="number" step="any"
                className={disabledInput + " text-right"}
                value={rnbFields.reduce(
                  (sum, _, i) =>
                    sum + toFiniteNumber(watch(`rnb_rows.${i}.covered`), 0),
                  0
                )}
                readOnly
              />
            </div>
          </div>
          <div className="mt-3">
            <p
              className={
                calculateTotalRnbDays() === calculateDaysConfined()
                  ? "text-green-700 bg-green-100 p-2 rounded text-sm"
                  : "text-red-700 bg-red-100 p-2 rounded text-sm"
              }
            >
              {calculateTotalRnbDays() === calculateDaysConfined()
                ? `Total R&B Days (${calculateTotalRnbDays()}) matches No. of Days Confined (${calculateDaysConfined()}).`
                : `Total R&B Days (${calculateTotalRnbDays()}) does NOT match No. of Days Confined (${calculateDaysConfined()}).`}
            </p>
          </div>
          {errors.rnb_rows && (
            <p className="text-xs text-red-500">{errors.rnb_rows.message}</p>
          )}
        </motion.section>
        {/* Surgical Benefit - Similar structure, abbreviated */}
        <motion.section
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={`space-y-3 rounded-lg border ${
            editingDisabled
              ? "border-gray-200 bg-gray-100 opacity-60"
              : "border-green-200 bg-green-50"
          } p-4 shadow-sm`}
        >
          <div className="flex items-center justify-between">
            <h5 className="flex items-center space-x-2 text-xs font-semibold text-gray-900">
              <FontAwesomeIcon
                icon={faStethoscope}
                className="text-green-500"
              />
              <span>(RUV) Surgical Benefit</span>
            </h5>
            {!editingDisabled && (
              <button
                type="button"
                onClick={() =>
                  appendSurg({
                    ruv_description: "",
                    remarks: "",
                    rnb_type: "",
                    ruv_unit: 0,
                    amount: 0,
                    philhealth: 0,
                    operating_room_amount: 0,
                  })
                }
                className="flex items-center space-x-1 px-4 py-1 bg-green-600 text-white rounded text-md hover:bg-green-700 disabled:opacity-50"
              >
                <FontAwesomeIcon icon={faPlus} />
                <span>Add RUV</span>
              </button>
            )}
          </div>
          {editingDisabled && (
            <p className="text-xs text-yellow-700">
              Editing disabled due to PhilHealth settings.
            </p>
          )}
          {/* Table for surgical rows similar to R&B */}
          <div className="overflow-auto">
            <table className="w-full min-w-[96rem] table-fixed border-collapse border border-gray-300">
              <thead>
                <tr className="bg-gray-100">
                  <th className={`${thBase} w-[28rem]`}>
                    RUV Description
                  </th>
                  <th className={`${thBase} w-[16rem]`}>Remarks</th>
                  <th className={`${thBase} w-[10rem]`}>R&B</th>
                  <th className={`${thBase} w-[8rem]`}>RUV Unit</th>
                  <th className={`${thBase} w-[9rem]`}>Amount</th>
                  <th className={`${thBase} w-[9rem]`}>PhilHealth</th>
                  <th className={`${thBase} w-[12rem]`}>Operating Room Amount</th>
                  <th className={`${thBase} w-[4rem]`}></th>
                </tr>
              </thead>
              <tbody>
                {surgFields.map((field, index) => {
                  const amountField = `surgical_rows.${index}.amount`;
                  const {
                    ref: amountRef,
                    onChange: amountOnChange,
                    ...amountRest
                  } = register(amountField, { disabled: editingDisabled });
                  const rnbField = `surgical_rows.${index}.rnb_type`;
                  const {
                    ref: rnbRef,
                    onChange: rnbOnChange,
                    ...rnbRest
                  } = register(rnbField, { disabled: editingDisabled });
                  return (
                    <tr
                      key={field.id}
                      className={editingDisabled ? "opacity-50" : ""}
                    >
                      <td className={`${tdBase} align-top`}>
                        <Select
                          cacheOptions
                          defaultOptions // Loads initial 20 on open/focus
                          loadOptions={loadRuvOptions}
                          value={selectedRvus[field.id]}
                          onChange={(opt) => {
                            handleRvuSelect(field.id, opt);
                          }}
                          placeholder="Search RUV (min 2 chars after initial load)..."
                          loadingMessage={() => "Searching RVUs..."}
                          noOptionsMessage={() => "Type to search RVUs"}
                          // Render menu in portal to avoid clipping by overflow containers
                          menuPortalTarget={
                            typeof document !== "undefined"
                              ? document.body
                              : null
                          }
                          menuPosition="fixed"
                          styles={ruvSelectStyles}
                          formatOptionLabel={formatCompactSelectLabel}
                          classNamePrefix="text-xs"
                          isDisabled={editingDisabled}
                          tabIndex={editingDisabled ? -1 : 0}
                          debounceTimeout={300}
                        />
                        {errors.surgical_rows?.[index]?.ruv_description && (
                          <p className="text-xs text-red-500 mt-1">
                            {
                              errors.surgical_rows[index].ruv_description
                                .message
                            }
                          </p>
                        )}
                      </td>
                      <td className={tdBase}>
                        <textarea
                          {...register(`surgical_rows.${index}.remarks`)}
                          className={`${inputBase} ${
                            editingDisabled ? "bg-gray-100 text-gray-500" : ""
                          }`}
                          readOnly={editingDisabled}
                          rows={2}
                        />
                      </td>
                      <td className={tdBase}>
                        <select
                          {...rnbRest}
                          ref={rnbRef}
                          className={`border p-2 rounded ${selectInputBase} ${
                            editingDisabled ? "bg-gray-100 text-gray-500" : ""
                          }`}
                          style={{
                            pointerEvents: editingDisabled ? "none" : "auto",
                          }}
                          tabIndex={editingDisabled ? -1 : 0}
                          onChange={(e) => {
                            rnbOnChange(e);
                            handleRnbChange(e, index);
                          }}
                        >
                          {RNB_OPTIONS.map((opt, i) => (
                            <option
                              key={i}
                              value={opt.value}
                              data-seq={opt.seq ?? ""}
                              data-rm_amt={opt.rm_amt ?? ""}
                              data-ip_rate={opt.ip_rate ?? ""}
                              // data-multiplier={opt.multiplier ?? ""}
                            >
                              {opt.label}
                            </option>
                          ))}
                        </select>
                      </td>
                      <td className={tdBase}>
                        <input
                          type="number" step="any"
                          disabled
                          value={watch(`surgical_rows.${index}.ruv_unit`)}
                          className={disabledInput}
                        />
                      </td>
                      <td className={tdBase}>
                        <input
                          {...amountRest}
                          ref={amountRef}
                          type="number" step="any"
                          onChange={(e) => {
                            amountOnChange(e);
                            setManualAmounts((prev) => ({
                              ...prev,
                              [field.id]: true,
                            }));
                          }}
                          className={inputBase}
                        />
                      </td>
                      <td className={tdBase}>
                        <input
                          type="number" step="any"
                          {...register(`surgical_rows.${index}.philhealth`, {
                            disabled: editingDisabled,
                          })}
                          className={inputBase}
                        />
                      </td>
                      <td className={tdBase}>
                        <input
                          type="number" step="any"
                          {...register(
                            `surgical_rows.${index}.operating_room_amount`,
                            { disabled: editingDisabled }
                          )}
                          className={inputBase}
                        />
                      </td>
                      <td className={tdBase}>
                        {!editingDisabled && (
                          <button
                            type="button"
                            onClick={() => removeSurg(index)}
                            className="text-red-500 hover:text-red-700 text-xs"
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="grid grid-cols-1 gap-4 md:grid-cols-4">
            <div className="space-y-1">
              <label className="block text-xs font-medium text-gray-700 text-right">
                Total RUV Unit
              </label>
              <input
                type="number" step="any"
                disabled
                value={surgicalComputations.totalRvuUnit}
                className={disabledInput + " text-right"}
              />
            </div>
            <div className="space-y-1">
              <label className="block text-xs font-medium text-gray-700 text-right">
                Total RUV Amount
              </label>
              <input
                type="number" step="any"
                disabled
                value={surgicalComputations.totalRuvAmt}
                className={disabledInput + " text-right"}
              />
            </div>
            <div className="space-y-1">
              <label className="block text-xs font-medium text-gray-700 text-right">
                Total PhilHealth
              </label>
              <input
                type="number" step="any"
                disabled
                value={surgicalComputations.totalSurPh}
                className={disabledInput + " text-right"}
              />
            </div>
            <div className="space-y-1">
              <label className="block text-xs font-medium text-gray-700 text-right">
                Total Operating Room Amount
              </label>
              <input
                type="number" step="any"
                disabled
                value={surgicalComputations.totalOr}
                className={disabledInput + " text-right"}
              />
            </div>
          </div>
        </motion.section>

        {/* Misc. Hospital Services - Aligned to others */}
        <motion.section
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={`space-y-3 rounded-lg border ${
            editingDisabled
              ? "border-gray-200 bg-gray-100 opacity-60"
              : "border-green-200 bg-green-50"
          } p-4 shadow-sm`}
        >
          <div className="flex items-center justify-between">
            <h5 className="flex items-center space-x-2 text-xs font-semibold text-gray-900">
              <FontAwesomeIcon icon={faGear} className="text-green-500" />
              <span>Misc. Hospital Services</span>
            </h5>
            {!editingDisabled && (
              <button
                type="button"
                onClick={handleAddMisc}
                className="flex items-center space-x-1 px-4 py-1 bg-green-600 text-white rounded text-md hover:bg-green-700 disabled:opacity-50"
              >
                <FontAwesomeIcon icon={faPlus} />
                <span>Add Misc</span>
              </button>
            )}
          </div>
          {editingDisabled && (
            <p className="text-xs text-yellow-700">
              Editing disabled due to PhilHealth settings.
            </p>
          )}
          <div className="overflow-auto">
            <table className="w-full min-w-[42rem] table-fixed border-collapse border border-gray-300">
              <thead>
                <tr className="bg-gray-100">
                  <th className={`${thBase} w-[28rem]`}>
                    Particulars <span className="text-red-500">*</span>
                  </th>
                  <th className={`${thBase} w-[10rem]`}>Amount</th>
                  <th className={`${thBase} w-[4rem]`}></th>
                </tr>
              </thead>
              <tbody>
                <AnimatePresence>
                  {miscFields.map((field, index) => (
                    <motion.tr
                      key={field.id}
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 0 }}
                      className={editingDisabled ? "opacity-50" : ""}
                    >
                      <td className={tdBase}>
                        <select
                          {...register(`misc_rows.${index}.particulars`, {
                            disabled: editingDisabled,
                          })}
                          className={selectInputBase}
                        >
                          <option value="">Select Particulars</option>
                          {miscServices.map((service) => (
                            <option
                              key={service.id || service.misc_desc}
                              value={service.misc_desc}
                            >
                              {service.misc_desc}
                            </option>
                          ))}
                        </select>
                      </td>
                      <td className={tdBase}>
                        <input
                          type="number" step="any"
                          {...register(`misc_rows.${index}.amount`, {
                            disabled: editingDisabled,
                          })}
                          className={inputBase}
                        />
                      </td>
                      <td className={tdBase}>
                        {!editingDisabled && (
                          <button
                            type="button"
                            onClick={() => removeMisc(index)}
                            className="text-red-500 hover:text-red-700 text-xs"
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        )}
                      </td>
                    </motion.tr>
                  ))}
                </AnimatePresence>
              </tbody>
            </table>
          </div>
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            <div className="space-y-1 md:col-span-2"></div>
            <div className="space-y-1">
              <label className="block text-xs font-medium text-gray-700 text-right">
                Total Miscellaneous
              </label>
              <input
                type="number" step="any"
                disabled
                value={miscComputations.totalMiscAmt}
                className={disabledInput + " text-right"}
              />
            </div>
            <div className="space-y-1">
              <label className="block text-xs font-medium text-gray-700 text-right">
                Total PhilHealth
              </label>
              <input
                type="number" step="any"
                {...register("misc_rows_philhealth", {
                  disabled: editingDisabled,
                })}
                className={inputBase + " text-right"}
              />
            </div>
          </div>
          {errors.misc_rows && (
            <p className="text-xs text-red-500">{errors.misc_rows.message}</p>
          )}
        </motion.section>

        {/* Physician Fee Benefit */}
        <motion.section
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={`space-y-3 rounded-lg border ${
            editingDisabled
              ? "border-gray-200 bg-gray-100 opacity-60"
              : "border-green-200 bg-green-50"
          } p-4 shadow-sm`}
        >
          <div className="flex items-center justify-between">
            <h5 className="flex items-center space-x-2 text-xs font-semibold text-gray-900">
              <FontAwesomeIcon icon={faUserMd} className="text-green-500" />
              <span>Physician Fee Benefit</span>

              
            </h5>
          
           

            <div className="flex flex-wrap items-center justify-end gap-2">
              {hasClaimSyncPhysicians && (
                <button
                  type="button"
                  onClick={handleSyncPhysicians}
                  disabled={claimSyncLoading || editingDisabled}
                  title="Sync Physicians from Process Claim"
                  className="inline-flex items-center gap-1 rounded border border-green-200 bg-white px-3 py-1 text-xs font-medium text-green-700 hover:bg-green-50 disabled:opacity-50"
                >
                  <FontAwesomeIcon
                    icon={claimSyncLoading ? faSpinner : faRefresh}
                    spin={claimSyncLoading}
                  />
                  <span>Sync</span>
                </button>
              )}
              {!editingDisabled && (
                <button
                  type="button"
                  onClick={() =>
                    appendPhys({
                      physician_id: null,
                      physician: "",
                      role: "",
                      amount: 0,
                      philhealth: 0,
                    })
                  }
                  className="flex items-center space-x-1 px-4 py-1 bg-blue-600 text-white rounded text-md hover:bg-blue-700 disabled:opacity-50"
                >
                  <FontAwesomeIcon icon={faPlus} />
                  <span>Add Physician</span>
                </button>
              )}
            </div>
          </div>
          {editingDisabled && (
            <p className="text-xs text-yellow-700">
              Editing disabled due to PhilHealth settings.
            </p>
          )}
          <div className="overflow-auto">
          
             <div className="flex items-center">
            <label className="flex items-center space-x-2 text-xs text-gray-700">
              <input
                type="checkbox"
                checked={onlyAffiliated}
                onChange={(e) => setOnlyAffiliated(e.target.checked)}
                disabled={editingDisabled}
                className="h-4 w-4"
              />
              <span>Only Show Affiliated Physician</span>
            </label>
          </div>

            <table className="w-full min-w-[62rem] table-fixed border-collapse border border-gray-300">
              <thead>
                <tr className="bg-gray-100">
                  <th className={`${thBase} w-[24rem]`}>
                    Physician <span className="text-red-500">*</span>
                  </th>
                  <th className={`${thBase} w-[16rem]`}>Role</th>
                  <th className={`${thBase} w-[9rem]`}>Amount</th>
                  <th className={`${thBase} w-[9rem]`}>PhilHealth</th>
                  <th className={`${thBase} w-[4rem]`}></th>
                </tr>
              </thead>
              <tbody>
                {physFields.map((field, index) => (
                  <tr
                    key={field.id}
                    className={editingDisabled ? "opacity-50" : ""}
                  >
                    <td className={`${tdBase} align-top`}>
                      <Select
                        value={buildPhysicianSelectValue(physicianRows[index])}
                        loadOptions={(input) => loadPhysicianOptions(input, onlyAffiliated)}
                        onChange={(opt) => {
                          setValue(
                            `physician_rows.${index}.physician`,
                            opt?.label || "",
                            { shouldDirty: true, shouldValidate: true }
                          );
                          setValue(
                            `physician_rows.${index}.physician_id`,
                            opt?.value || null,
                            { shouldDirty: true, shouldValidate: true }
                          );
                          setValue(
                            `physician_rows.${index}.physician_option`,
                            opt || null,
                            { shouldDirty: true }
                          );
                        }}
                        placeholder="Search Physician..."
                        isDisabled={editingDisabled}
                        classNamePrefix="text-xs"
                        menuPortalTarget={
                          typeof document !== "undefined" ? document.body : null
                        }
                        menuPosition="fixed"
                        styles={physicianSelectStyles}
                        formatOptionLabel={(opt, { context }) => {
                          const affiliated = opt?.is_affiliated;
                          const status = opt?.affiliation_status;
                          const physicianName =
                            String(
                              opt?.label ||
                                opt?.full_name ||
                                opt?.raw?.full_name ||
                                opt?.raw?.label ||
                                [
                                  opt?.first_name,
                                  opt?.middle_name,
                                  opt?.last_name,
                                ]
                                  .filter(Boolean)
                                  .join(" ")
                            )
                              .replace(/\s+/g, " ")
                              .trim() || "Unnamed Physician";
                          const badgeColor = affiliated
                            ? "bg-green-100 text-green-800"
                            : "bg-red-100 text-red-800";
                          const isMenu = context === "menu";
                          // For menu list and single value, render label + badge
                          return (
                            <div
                              className="flex items-center justify-between w-full gap-2"
                              title={physicianName}
                            >
                              <div
                                className={`min-w-0 flex-1 text-sm text-gray-900 ${
                                  isMenu
                                    ? "whitespace-normal break-words leading-snug"
                                    : "truncate"
                                }`}
                              >
                                {physicianName}
                              </div>
                              {status && (
                                <span
                                  className={`${badgeColor} text-xs font-medium px-2 py-0.5 rounded-full ml-2 whitespace-nowrap`}
                                >
                                  {status}
                                </span>
                              )}
                            </div>
                          );
                        }}
                      />
                    </td>
                    <td className={tdBase}>
                      <select
                        {...register(`physician_rows.${index}.role`, {
                          disabled: editingDisabled,
                        })}
                        className={selectInputBase}
                        onChange={(e) => {
                          const role = e.target.value;
                          // if (role && role !== "") {
                          // notes: kapag Surgeon ang magiging default value nung amount nya is yung Total RUV Amount
                          if (role && role !== "" && role === "Surgeon") {
                            console.log(role);
                            // Default amount to Total RUV Amount when role is selected
                            const totalRuvAmt =
                              surgicalComputations.totalRuvAmt || 0;
                            setValue(
                              `physician_rows.${index}.amount`,
                              totalRuvAmt
                            );
                          } else if (
                            role &&
                            role !== "" &&
                            role === "Anesthesiologist"
                          ) {
                            // UPDATED: Default for Anesthesiologist is 50% of Total RUV Amount
                            const totalRuvAmt =
                              surgicalComputations.totalRuvAmt || 0;
                            setValue(
                              `physician_rows.${index}.amount`,
                              totalRuvAmt * 0.5
                            );
                          } else if (
                            role &&
                            role !== "" &&
                            role === "Assistant Surgeon"
                          ) {
                            // UPDATED: Default for Assistant Surgeon is 25% of Total RUV Amount
                            const totalRuvAmt =
                              surgicalComputations.totalRuvAmt || 0;
                            setValue(
                              `physician_rows.${index}.amount`,
                              totalRuvAmt * 0.25
                            );
                          }
                        }}
                      >
                        <option value="">Select Role</option>
                        <option value="Attending Physician">
                          Attending Physician
                        </option>
                        <option value="Surgeon">Surgeon</option>
                        <option
                          value="Assistant Surgeon"
                          disabled={
                            editingDisabled ||
                            (surgicalComputations?.totalRvuUnit || 0) <= 200
                          }
                          title={
                            (surgicalComputations?.totalRvuUnit || 0) > 200
                              ? ""
                              : "RUV Unit must be more than 200 to add assistant surgeon"
                          }
                        >
                          Assistant Surgeon
                        </option>
                        <option value="Reader">Reader</option>
                        <option value="Specialist">Specialist</option>
                        <option value="Anesthesiologist">
                          Anesthesiologist
                        </option>
                      </select>
                    </td>
                    <td className={tdBase}>
                      <input
                        type="number"
                        step="0.01"
                        {...register(`physician_rows.${index}.amount`, {
                          disabled: editingDisabled,
                        })}
                        className={inputBase}
                      />
                    </td>
                    <td className={tdBase}>
                      <input
                        type="number"
                        step="0.01"
                        {...register(`physician_rows.${index}.philhealth`, {
                          disabled: editingDisabled,
                        })}
                        className={inputBase}
                      />
                    </td>
                    <td className={tdBase}>
                      {!editingDisabled && (
                        <button
                          type="button"
                          onClick={() => removePhys(index)}
                          className="text-red-500 hover:text-red-700 text-xs"
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {/* UPDATED: New totals grid for Surgical and Anesthesiologist specifics */}
          <div className="grid grid-cols-1 gap-4 md:grid-cols-4">
            <div className="space-y-1">
              <label className="block text-xs font-medium text-gray-700 text-right">
                Total Surgical Fee Amount
              </label>
              <input
                type="number"
                disabled
                value={surgicalPhysAmount}
                className={disabledInput + " text-right"}
              />
            </div>
            <div className="space-y-1">
              <label className="block text-xs font-medium text-gray-700 text-right">
                Total Surgical PhilHealth Amount
              </label>
              <input
                type="number"
                disabled
                value={surgicalPhysPh}
                className={disabledInput + " text-right"}
              />
            </div>
            <div className="space-y-1">
              <label className="block text-xs font-medium text-gray-700 text-right">
                Total Anesthesiologist Fee Amount
              </label>
              <input
                type="number"
                disabled
                value={anesAmount}
                className={disabledInput + " text-right"}
              />
            </div>
            <div className="space-y-1">
              <label className="block text-xs font-medium text-gray-700 text-right">
                Total Anesthesiologist PhilHealth Amount
              </label>
              <input
                type="number"
                disabled
                value={anesPh}
                className={disabledInput + " text-right"}
              />
            </div>
          </div>
          {errors.physician_rows && (
            <p className="text-xs text-red-500">
              {errors.physician_rows.message}
            </p>
          )}
        </motion.section>

        {/* Summary of Benefits - UPDATED: Full computed values */}
        <motion.section
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="space-y-3 rounded-lg border border-indigo-200 bg-indigo-50 p-4 shadow-sm overflow-auto"
        >
          <details className="group rounded-lg border border-indigo-200 bg-white">

    
          <h5 className="flex items-center space-x-2 text-md font-semibold text-red-400">
            <FontAwesomeIcon icon={faShieldAlt} className="text-indigo-500" />
            <span>WARNING: (please ignore this) Old Version of Summary of Benefits - you should proceed to "Finilize Discharge Summary"</span>
          </h5>
          <div className="overflow-auto">
            <table className="w-full table-auto border-collapse border border-gray-300">
              <thead>
                <tr className="bg-gray-100">
                  <th className={thBase}>Benefit Description</th>
                  <th className={thBase}>Basic Limit</th>
                  <th className={thBase}>Major Limit</th>
                  <th className={thBase}>Basic Remaining</th>
                  <th className={thBase}>Major Remaining</th>
                  <th className={thBase}>Incurred</th>
                  <th className={thBase}>PhilHealth</th>
                  <th className={thBase}>Basic Covered</th>
                  <th className={thBase}>Major Covered</th>
                  <th className={thBase}>Excess</th>
                </tr>
              </thead>
              <tbody>
                {/* Room & Board Row - UPDATED */}
                <tr>
                  <td className="border px-2 py-1 font-medium text-xs">
                    Room & Board
                  </td>
                  <td className={tdBase}>
                    <input
                      type="text"
                      disabled
                      value={summary.rnb?.basicLimit || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="text"
                      disabled
                      value={summary.rnb?.majorLimit || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="text"
                      disabled
                      value={summary.rnb?.basicRemaining || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="text"
                      disabled
                      value={summary.rnb?.majorRemaining || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="number" step="any"
                      disabled
                      value={summary.rnb?.incurred || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="number" step="any"
                      disabled
                      value={summary.rnb?.philhealth || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="number" step="any"
                      disabled
                      value={summary.rnb?.basicCovered || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="number" step="any"
                      disabled
                      value={summary.rnb?.majorCovered || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="number" step="any"
                      disabled
                      value={summary.rnb?.excess || 0}
                      className={disabledInput}
                    />
                  </td>
                </tr>
                {/* Surgical Fee Row - UPDATED */}
                <tr>
                  <td className="border px-2 py-1 font-medium text-xs">
                    Surgical Fee
                  </td>
                  <td className={tdBase}>
                    <input
                      type="text"
                      disabled
                      value={summary.surgical?.basicLimit || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="text"
                      disabled
                      value={summary.surgical?.majorLimit || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="text"
                      disabled
                      value={summary.surgical?.basicRemaining || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="text"
                      disabled
                      value={summary.surgical?.majorRemaining || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="number" step="any"
                      disabled
                      value={summary.surgical?.incurred || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="number" step="any"
                      disabled
                      value={summary.surgical?.philhealth || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="number" step="any"
                      disabled
                      value={summary.surgical?.basicCovered || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="number" step="any"
                      disabled
                      value={summary.surgical?.majorCovered || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="number" step="any"
                      disabled
                      value={summary.surgical?.excess || 0}
                      className={disabledInput}
                    />
                  </td>
                </tr>
                {/* Misc Row - UPDATED */}
                <tr>
                  <td className="border px-2 py-1 font-medium text-xs">
                    Misc. Hospital Services
                  </td>
                  <td className={tdBase}>
                    <input
                      type="text"
                      disabled
                      value={summary.misc?.basicLimit || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="text"
                      disabled
                      value={summary.misc?.majorLimit || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="text"
                      disabled
                      value={summary.misc?.basicRemaining || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="text"
                      disabled
                      value={summary.misc?.majorRemaining || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="number" step="any"
                      disabled
                      value={summary.misc?.incurred || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="number" step="any"
                      disabled
                      value={summary.misc?.philhealth || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="number" step="any"
                      disabled
                      value={summary.misc?.basicCovered || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="number" step="any"
                      disabled
                      value={summary.misc?.majorCovered || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="number" step="any"
                      disabled
                      value={summary.misc?.excess || 0}
                      className={disabledInput}
                    />
                  </td>
                </tr>
                {/* Phys Row - UPDATED */}
                <tr>
                  <td className="border px-2 py-1 font-medium text-xs">
                    Physician Fee Benefit
                  </td>
                  <td className={tdBase}>
                    <input
                      type="text"
                      disabled
                      value={summary.phys?.basicLimit || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="text"
                      disabled
                      value={summary.phys?.majorLimit || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="text"
                      disabled
                      value={summary.phys?.basicRemaining || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="text"
                      disabled
                      value={summary.phys?.majorRemaining || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="number" step="any"
                      disabled
                      value={summary.phys?.incurred || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="number" step="any"
                      disabled
                      value={summary.phys?.philhealth || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="number" step="any"
                      disabled
                      value={summary.phys?.basicCovered || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="number" step="any"
                      disabled
                      value={summary.phys?.majorCovered || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="number" step="any"
                      disabled
                      value={summary.phys?.excess || 0}
                      className={disabledInput}
                    />
                  </td>
                </tr>
                {/* Anes Row - UPDATED */}
                <tr>
                  <td className="border px-2 py-1 font-medium text-xs">
                    Anesthesiologist Fee Benefit
                  </td>
                  <td className={tdBase}>
                    <input
                      type="text"
                      disabled
                      value={summary.anes?.basicLimit || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="text"
                      disabled
                      value={summary.anes?.majorLimit || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="text"
                      disabled
                      value={summary.anes?.basicRemaining || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="text"
                      disabled
                      value={summary.anes?.majorRemaining || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="number" step="any"
                      disabled
                      value={summary.anes?.incurred || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="number" step="any"
                      disabled
                      value={summary.anes?.philhealth || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="number" step="any"
                      disabled
                      value={summary.anes?.basicCovered || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="number" step="any"
                      disabled
                      value={summary.anes?.majorCovered || 0}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <input
                      type="number" step="any"
                      disabled
                      value={summary.anes?.excess || 0}
                      className={disabledInput}
                    />
                  </td>
                </tr>
                {/* Total Row - UPDATED */}
                <tr className="font-semibold">
                  <td colSpan={5} className="border px-2 py-1 text-right pr-2">
                    <button
                      type="button"
                      disabled={
                        editingDisabled ||
                        submitting ||
                        finalizeLoading ||
                        computed
                      }
                      onClick={handleFinalizeComputation}
                      className="px-4 py-1 bg-blue-600 text-white rounded text-md hover:bg-blue-700 disabled:opacity-50 flex items-center space-x-1 ml-auto"
                    >
                      <FontAwesomeIcon
                        icon={finalizeLoading ? faSpinner : faRefresh}
                        spin={finalizeLoading}
                      />
                      <span>
                        {computed ? "Computed" : "Finalize Computation"}
                      </span>
                    </button>
                  </td>
                  <td className={tdBase}>
                    <label className="block text-xs font-medium mb-1 text-right">
                      <b>Total Incurred</b>
                    </label>
                    <input
                      type="number" step="any"
                      disabled
                      value={totals.incurred}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <label className="block text-xs font-medium mb-1 text-right">
                      <b>Total PhilHealth</b>
                    </label>
                    <input
                      type="number" step="any"
                      disabled
                      value={totals.ph}
                      className={disabledInput}
                    />
                  </td>
                  <td colSpan={2} className="border px-2 py-1">
                    <label className="block text-xs font-medium mb-1 text-right">
                      <b>Total Covered</b>
                    </label>
                    <input
                      type="number" step="any"
                      disabled
                      value={totals.covered}
                      className={disabledInput}
                    />
                  </td>
                  <td className={tdBase}>
                    <label className="block text-xs font-medium mb-1 text-right">
                      <b>Total Excess</b>
                    </label>
                    <input
                      type="number" step="any"
                      disabled
                      value={totals.excess}
                      className={disabledInput}
                    />
                  </td>
                </tr>
              </tbody>
            </table>

          </div>
           
</details>
          <hr className="my-3 border-gray-200" />
          {/* UPDATED: Wire Phil checkboxes to handler */}
          <div className="mt-2">
            <label className="flex items-center space-x-2 text-xs">
              <input
                type="checkbox"
                {...register("ph_file")}
                className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 h-3 w-3"
              />
              <span>Member did not file PhilHealth</span>
            </label>
            <label className="flex items-center space-x-2 text-xs">
              <input
                type="checkbox"
                {...register("ph_comp")}
                className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 h-3 w-3"
              />
              <span>PhilHealth Non-Compensable</span>
            </label>
          </div>
          {/* Totals Table */}
          <table className="w-full table-auto border-collapse border border-gray-300">
            <tbody>
              <tr>
                <td className={tdBase}>
                  <div className="space-y-2">
                    <label className="flex items-center space-x-2 text-xs">
                      <input
                        type="checkbox"
                        {...register("corporate_guarantee")}
                        className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 h-3 w-3"
                      />
                      <span>Corporate Guarantee</span>
                    </label>
                    <label className="flex items-center space-x-2 text-xs">
                      <input
                        type="checkbox"
                        {...register("provider_guarantee")}
                        className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 h-3 w-3"
                      />
                      <span>Provider Guarantee</span>
                    </label>
                  </div>
                </td>
                <td className={tdBase}>
                  <label className="block text-xs font-medium mb-1">
                    Guaranteed Amount
                  </label>
                  <input
                    type="number"
                    {...register("guaranteed_amount")}
                    disabled={!corporateGuarantee}
                    className={inputBase}
                  />
                </td>
                <td className="border px-2 py-1 hidden">
                  <label className="block text-xs font-medium mb-1">
                    Member Share Amount
                  </label>
                  <input
                    type="number"
                    {...register("member_share_amount")}
                    className={inputBase}
                  />
                </td>
                <td className={tdBase}>
                  <label className="block text-xs font-medium mb-1">
                    Corporate Approved By
                  </label>
                  <input
                    {...register("corp_approved_by")}
                    disabled={!corporateGuarantee}
                    className={inputBase}
                  />
                </td>
                <td className={tdBase}>
                  <label className="block text-xs font-medium mb-1">
                    AMAP Approved By
                  </label>
                  <input
                    {...register("amap_approved_by")}
                    disabled={!providerGuarantee}
                    className={inputBase}
                  />
                </td>
                <td className={tdBase}>
                  <label className="block text-xs font-medium mb-1">
                    Remarks
                  </label>
                  <textarea
                    {...register("remarks")}
                    className={inputBase}
                    rows={3}
                    placeholder="Enter your remarks here..."
                    maxLength={1000}
                  />
                </td>
              </tr>
              <tr>
                <td className={tdBase} colSpan={2}></td>
                <td className={tdBase}>
                  <label className="block text-xs font-medium mb-1">
                    Uncovered Item Amount
                  </label>
                  <input
                    type="number" step="any"
                    {...register("uncovered_amount")}
                    disabled
                    value={totals.uncovered}
                    className={disabledInput}
                  />
                </td>
                <td colSpan={3} className={tdBase}>
                  <div className="w-full">
                    <div className="mb-1 flex items-center justify-between gap-2">
                      <label className="block text-xs font-medium">
                        (claim_remarks)Uncovered Item Remarks
                      </label>
                      {hasClaimSyncRemarks && (
                        <button
                          type="button"
                          onClick={handleSyncClaimRemarks}
                          disabled={claimSyncLoading}
                          title="Sync Claim Remarks from Process Claim"
                          className="inline-flex items-center gap-1 rounded border border-amber-200 bg-white px-2 py-1 text-[11px] font-medium text-amber-700 hover:bg-amber-50 disabled:opacity-50"
                        >
                          <FontAwesomeIcon
                            icon={claimSyncLoading ? faSpinner : faRefresh}
                            spin={claimSyncLoading}
                          />
                          <span>Sync</span>
                        </button>
                      )}
                    </div>
                    <textarea
                      {...register("claim_remarks")}
                      className={inputBase + " resize-vertical"}
                      placeholder="Enter Uncovered Item Remarks"
                      rows={3}
                      maxLength={5000}
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </motion.section>

        {/* Sticky submit footer */}
        <div className="sticky bottom-0 z-30 -mx-4 flex justify-end space-x-3 border-t border-gray-200 bg-white px-4 py-3 shadow-[0_-4px_12px_rgba(15,23,42,0.08)]">
          {/* <button
            type="button"
            onClick={onCancel}
            className="px-3 py-1 border border-gray-300 rounded text-xs text-gray-700 hover:bg-gray-50"
          >
            Close
          </button> */}
          <button
            type="submit"
            // disabled={submitting || editingDisabled}
            className="flex items-center space-x-1 px-5 py-2 bg-green-600 text-white rounded text-lg hover:bg-green-700 disabled:opacity-50"
          >
            <FontAwesomeIcon
              icon={submitting ? faSpinner : faFileCircleCheck}
              spin={submitting}
            />
            <span>{submitting ? "Processing..." : "Finalize Discharge Summary"}</span>
          </button>
        </div>
      </form>

      {/* Summary Modal */}
      {showSummaryModal && summaryData && (
        <div className={`fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 ${isMaximized ? 'p-0' : ''}`}>
          <div className={`bg-white rounded-lg ${isMaximized ? 'w-full h-full max-w-none max-h-none' : 'max-w-4xl w-full max-h-[90vh]'} overflow-hidden flex flex-col`}>
            <div className="flex flex-shrink-0 justify-between items-center border-b border-gray-200 px-6 py-4">
              <h2 className="text-xl font-bold text-gray-900">Discharge Summary Preview</h2>
              <div className="flex items-center space-x-2">
                <button
                  onClick={() => setIsMaximized(!isMaximized)}
                  className="inline-flex items-center gap-2 rounded border border-gray-300 px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-50"
                  title={isMaximized ? "Exit full page" : "View full page"}
                >
                  <FontAwesomeIcon icon={isMaximized ? faWindowRestore : faWindowMaximize} />
                  <span>{isMaximized ? "Exit Full Page" : "View Full Page"}</span>
                </button>
                <button
                  onClick={() => setShowSummaryModal(false)}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <FontAwesomeIcon icon={faTimes} />
                </button>
              </div>
            </div>

            <div className="flex flex-shrink-0 gap-2 border-b border-gray-200 bg-gray-50 px-6 py-3">
              <button
                type="button"
                onClick={() => setSummaryModalTab("discharge")}
                className={`rounded px-4 py-2 text-sm font-semibold ${
                  summaryModalTab === "discharge"
                    ? "bg-indigo-600 text-white"
                    : "bg-white text-gray-700 hover:bg-gray-100"
                }`}
              >
                Discharge Summary
              </button>
              <button
                type="button"
                onClick={() => setSummaryModalTab("benefits")}
                className={`rounded px-4 py-2 text-sm font-semibold ${
                  summaryModalTab === "benefits"
                    ? "bg-indigo-600 text-white"
                    : "bg-white text-gray-700 hover:bg-gray-100"
                }`}
              >
                Summary of Benefits
              </button>
            </div>

            <div className="min-h-0 flex-1 overflow-y-auto px-6 py-4">
              {summaryModalTab === "discharge" ? (
                <div className="space-y-4">
                {/* Accordion Sections */}
                {/** Helper to toggle sections */}
                {/* Member Info */}
                <div className="border rounded">
                  <button
                    type="button"
                    onClick={() => setOpenSections((p) => ({ ...p, member: !p.member }))}
                    className="w-full text-left px-4 py-3 bg-gray-100 font-semibold"
                  >
                    Member Information
                  </button>
                  {openSections.member && (
                    <div className="p-4 text-sm space-y-2">
                      <div><span className="font-bold text-base">Company Name:</span> <span className="ml-2">{summaryData?.summary?.member?.corp_name || 'N/A'}</span></div>
                      <div><span className="font-bold text-base">Member Name:</span> <span className="ml-2">{summaryData?.summary?.member?.member_name || 'N/A'}</span></div>
                      <div><span className="font-bold text-base">Member ID:</span> <span className="ml-2">{summaryData?.summary?.member?.member_id || 'N/A'}</span></div>
                      <div><span className="font-bold text-base">Plan Expiry:</span> <span className="ml-2">{summaryData?.summary?.member?.expiry_date || 'N/A'}</span></div>
                      <div><span className="font-bold text-base">Civil Status:</span> <span className="ml-2">{summaryData?.summary?.member?.civil_status || 'N/A'}</span></div>
                      <div><span className="font-bold text-base">Gender:</span> <span className="ml-2">{summaryData?.summary?.member?.gender || 'N/A'}</span></div>
                      <div><span className="font-bold text-base">Birth Date:</span> <span className="ml-2">{summaryData?.summary?.member?.date_of_birth || 'N/A'}</span></div>
                      <div>
                        <span className="font-bold text-base">Age:</span>
                        <span className="ml-2">{
                          summaryData?.summary?.member?.date_of_birth ? Math.floor((new Date() - new Date(summaryData.summary.member.date_of_birth)) / (365.25 * 24 * 60 * 60 * 1000)) : 'N/A'
                        }</span>
                      </div>
                    </div>
                  )}
                </div>

              {/* Provider Info */}
              <div className="border rounded">
                <button
                  type="button"
                  onClick={() => setOpenSections((p) => ({ ...p, provider: !p.provider }))}
                  className="w-full text-left px-4 py-3 bg-gray-100 font-semibold"
                >
                  Provider Information
                </button>
                {openSections.provider && (
                  <div className="p-4 text-sm space-y-2">
                    <div><span className="font-bold">Issued To (Provider Name):</span> <span className="ml-2">{summaryData?.summary?.provider?.name || 'N/A'}</span></div>
                    <div><span className="font-bold">Provider ID:</span> <span className="ml-2">{summaryData?.summary?.provider?.code || 'N/A'}</span></div>
                  </div>
                )}
              </div>

              {/* Financials */}
              <div className="border rounded">
                <button
                  type="button"
                  onClick={() => setOpenSections((p) => ({ ...p, finance: !p.finance }))}
                  className="w-full text-left px-4 py-3 bg-gray-100 font-semibold"
                >
                  Financial Summary
                </button>
                {openSections.finance && (
                  <div className="p-4 text-sm space-y-3">
                    <div className="text-2xl font-bold text-red-500">Total Approved Amount: <span className="ml-2">{formatBenefitMoney(summaryData?.summary?.financial?.total_covered)}</span></div>
                    <div className="font-semibold">Final Diagnosis: <span className="font-normal ml-2">{summaryData?.summary?.transaction?.diagnosis || 'N/A'}</span></div>
                    <div className="font-semibold">Hospital Bill: <span className="font-normal ml-2">{formatBenefitMoney(summaryData?.summary?.financial?.hospital_bill)}</span></div>
                    <div className="font-semibold">Remarks: <span className="font-normal ml-2">{summaryData?.summary?.transaction?.claim_remarks || 'N/A'}</span></div>
                    {(toFiniteNumber(summaryData?.summary?.financial?.total_excess, 0) > 0) && (
                      <div className="mt-2 text-lg font-bold text-red-700">AMAPHIL Member has to settle the excess amounting to: <span>{formatBenefitMoney(summaryData.summary.financial.total_excess)}</span> only</div>
                    )}
                  </div>
                )}
              </div>

              {/* Professional Fees / RUV */}
              <div className="border rounded">
                <button
                  type="button"
                  onClick={() => setOpenSections((p) => ({ ...p, pf: !p.pf }))}
                  className="w-full text-left px-4 py-3 bg-gray-100 font-semibold"
                >
                  Professional Fees (PF) & Surgeons (RUV)
                </button>
                {openSections.pf && (
                  <div className="p-4 text-sm space-y-3">
                    <div>
                      <div className="font-bold">List of PF / Professional Fee</div>
                      <ul className="list-disc list-inside">
                        {(summaryData?.summary?.physician_rows || []).map((p, idx) => (
                          <li key={idx} className="flex justify-between">
                            <span className="font-medium">{p.physician || p.physician_name || 'N/A'}</span>
                            <span className="font-semibold">{formatBenefitMoney(p.amount)}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div>
                      <div className="font-bold">Surgeon(s) (RUV)</div>
                      <ul className="list-disc list-inside">
                        {(summaryData?.summary?.physician_rows || []).filter(p=> (p.role||'').toLowerCase()=== 'surgeon').map((s, i) => (
                          <li key={i} className="flex justify-between">
                            <span className="font-medium">{s.physician || s.physician_name || 'N/A'}</span>
                            <span className="font-semibold">{formatBenefitMoney(s.amount)}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}
              </div>

              {/* Backend Process Steps Accordion with SQL */}
              <div className="border rounded">
                <button
                  type="button"
                  onClick={() => setOpenSections((p) => ({ ...p, backend: !p.backend }))}
                  className="w-full text-left px-4 py-3 bg-gray-100 font-semibold"
                >
                  (please ignore this) IT References: Backend Process Steps (click to expand)
                </button>
                {openSections.backend && (
                  <div className="p-4 text-sm space-y-2">
                    {summaryData.summary && Object.entries(summaryData.summary).map(([step, data]) => (
                      <div key={step} className="bg-gray-50 p-3 rounded">
                        <div className="flex justify-between items-center">
                          <span className="font-medium">{step.replace('step', 'Step ')}</span>
                          <span className={`text-sm px-2 py-1 rounded ${data.success ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                            {data.success ? 'Success' : 'Failed'}
                          </span>
                        </div>
                        {data.message && <p className="text-sm text-gray-600 mt-1">{data.message}</p>}
                        {/* Display queries if available */}
                        {data.data && (
                          <div className="mt-2">
                            {data.data.insert_sql && <div className="text-xs text-gray-600 font-medium">Insert SQL:</div>}
                            {data.data.insert_sql && <pre className="text-xs bg-white border p-2 overflow-x-auto">{data.data.insert_sql}</pre>}
                            {data.data.insert_bindings && <div className="text-xs text-gray-600">Bindings: {JSON.stringify(data.data.insert_bindings)}</div>}

                            {data.data.update_sql && <div className="text-xs text-gray-600 font-medium mt-1">Update SQL:</div>}
                            {data.data.update_sql && <pre className="text-xs bg-white border p-2 overflow-x-auto">{data.data.update_sql}</pre>}
                            {data.data.update_bindings && <div className="text-xs text-gray-600">Bindings: {JSON.stringify(data.data.update_bindings)}</div>}

                            {data.data.resolved_sql_query && (
                              <>
                                <div className="text-xs text-gray-600 font-medium mt-1">Resolved Query:</div>
                                <pre className="text-xs bg-white border p-2 overflow-x-auto">{typeof data.data.resolved_sql_query === 'string' ? data.data.resolved_sql_query : JSON.stringify(data.data.resolved_sql_query)}</pre>
                              </>
                            )}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
              ) : (
                <div className="space-y-4">
                  <div className="grid grid-cols-1 gap-3 md:grid-cols-5">
                    <div className="rounded border bg-gray-50 p-3">
                      <p className="text-xs font-semibold text-gray-500">Total Incurred</p>
                      <p className="text-sm font-bold text-gray-900">{formatBenefitMoney(summaryBenefitTotals.incurred)}</p>
                    </div>
                    <div className="rounded border bg-gray-50 p-3">
                      <p className="text-xs font-semibold text-gray-500">Total PhilHealth</p>
                      <p className="text-sm font-bold text-gray-900">{formatBenefitMoney(summaryBenefitTotals.philhealth)}</p>
                    </div>
                    <div className="rounded border bg-gray-50 p-3">
                      <p className="text-xs font-semibold text-gray-500">Total Covered</p>
                      <p className="text-sm font-bold text-green-700">{formatBenefitMoney(summaryBenefitTotals.covered)}</p>
                    </div>
                    <div className="rounded border bg-gray-50 p-3">
                      <p className="text-xs font-semibold text-gray-500">Total Excess</p>
                      <p className="text-sm font-bold text-red-700">{formatBenefitMoney(summaryBenefitTotals.excess)}</p>
                    </div>
                    <div className="rounded border bg-gray-50 p-3">
                      <p className="text-xs font-semibold text-gray-500">Uncovered Items</p>
                      <p className="text-sm font-bold text-red-700">{formatBenefitMoney(summaryBenefitTotals.uncovered)}</p>
                    </div>
                  </div>

                  <div className="overflow-x-auto rounded border border-gray-200">
                    <table className="min-w-full border-collapse text-sm">
                      <thead className="bg-gray-100 text-xs uppercase text-gray-600">
                        <tr>
                          <th className="border px-3 py-2 text-left">Benefit Description</th>
                          <th className="border px-3 py-2 text-left">Benefit Code</th>
                          <th className="border px-3 py-2 text-right">Basic Limit</th>
                          <th className="border px-3 py-2 text-right">Major Limit</th>
                          <th className="border px-3 py-2 text-right">Basic Remaining</th>
                          <th className="border px-3 py-2 text-right">Major Remaining</th>
                          <th className="border px-3 py-2 text-right">Incurred</th>
                          <th className="border px-3 py-2 text-right">PhilHealth</th>
                          <th className="border px-3 py-2 text-right">Basic Covered</th>
                          <th className="border px-3 py-2 text-right">Major Covered</th>
                          <th className="border px-3 py-2 text-right">Excess</th>
                        </tr>
                      </thead>
                      <tbody>
                        {summaryBenefitRows.map(({ key, code, description, values }) => (
                          <tr key={key} className="odd:bg-white even:bg-gray-50">
                            <td className="border px-3 py-2 font-semibold text-gray-900">{description}</td>
                            <td className="border px-3 py-2 text-gray-700">{code}</td>
                            <td className="border px-3 py-2 text-right">{formatBenefitValue(values.basicLimit)}</td>
                            <td className="border px-3 py-2 text-right">{formatBenefitValue(values.majorLimit)}</td>
                            <td className="border px-3 py-2 text-right">{formatBenefitValue(values.basicRemaining)}</td>
                            <td className="border px-3 py-2 text-right">{formatBenefitValue(values.majorRemaining)}</td>
                            <td className="border px-3 py-2 text-right">{formatBenefitMoney(values.incurred)}</td>
                            <td className="border px-3 py-2 text-right">{formatBenefitMoney(values.philhealth)}</td>
                            <td className="border px-3 py-2 text-right">{formatBenefitMoney(values.basicCovered)}</td>
                            <td className="border px-3 py-2 text-right">{formatBenefitMoney(values.majorCovered)}</td>
                            <td className="border px-3 py-2 text-right font-semibold text-red-700">{formatBenefitMoney(values.excess)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>

            <div className="flex-shrink-0 border-t border-gray-200 bg-white px-6 py-4 shadow-[0_-4px_12px_rgba(15,23,42,0.08)]">
              <ModalActionButtons
                onCancel={() => setShowSummaryModal(false)}
                onConfirm={handleConfirmDischarge}
                confirming={confirmingDischarge}
                totalApproved={summaryData?.summary?.financial?.total_covered || 0}
              />
            </div>
          </div>
        </div>
      )}

      {/* AI Chat Drawer for ICD Search */}
      {ENABLE_AI_ICD_SEARCH && (
        <AiIcdChat
          isOpen={aiChatOpen}
          onClose={closeAiChat}
          messages={aiMessages}
          onSend={sendAiMessage}
          loading={aiLoading}
          onClear={() => setAiMessages([])}
          title="AI ICD Code Fast Search"
          placeholder="Example Ask: What is the icd code for UPPER GI BLEEDING, TO BLEEDING PEPTIC ULCER"
          initialInput={watch("final_diagnosis") ? `Final Diagnosis: ${watch("final_diagnosis")}` : ""}
        />
      )}

      <div className="grid grid-cols-2 gap-4 md:grid-cols-2 lg:grid-cols-2">
        {/* Proof of Guarantee Upload Section - Conditional */}
        <AnimatePresence>
          {corporateGuarantee && (
            <motion.section
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: "auto" }}
              exit={{ opacity: 0, height: 0 }}
              className="space-y-3 rounded-lg border border-indigo-200 bg-indigo-50 p-4 shadow-sm"
            >
              <h5 className="flex items-center space-x-2 text-xs font-semibold text-gray-900">
                <FontAwesomeIcon
                  icon={faShieldAlt}
                  className="text-indigo-500"
                />
                <span>Attach Proof of Guarantee</span>
              </h5>
              {/* File Upload Area - unchanged */}
              <div className="mt-3">
                <div
                  className={`relative border-2 border-dashed rounded-lg p-4 text-center transition-all duration-300 ${
                    isDraggingProof
                      ? "border-indigo-500 bg-indigo-50 scale-105"
                      : "border-gray-300 bg-gray-50"
                  }`}
                  onDragOver={handleDragOverProof}
                  onDragLeave={handleDragLeaveProof}
                  onDrop={handleDropProof}
                >
                  <FontAwesomeIcon
                    icon={faUpload}
                    className="text-2xl text-indigo-500 mb-2"
                  />
                  <p className="text-gray-700 text-sm">
                    Drag and drop PDF or image files here or{" "}
                    <button
                      type="button"
                      onClick={handleChooseProofFile}
                      className="text-indigo-600 font-medium hover:text-indigo-800 transition-colors text-xs"
                    >
                      choose files
                    </button>
                  </p>
                  <p className="text-xs text-gray-500 mt-1">
                    Supported formats: .pdf, .jpg, .jpeg, .png (Allowed size:{" "}
                    {uploadFileSizeLimitLabel} per file, up to {maxUploadLimit} files)
                  </p>
                  <input
                    type="file"
                    ref={proofFileInputRef}
                    multiple
                    accept=".pdf,.jpg,.jpeg,.png"
                    onChange={(e) => handleProofFileChange(e.target.files)}
                    className="hidden"
                  />
                </div>
              </div>
              {/* File List - now shows loaded files too */}
              {proofFiles.length > 0 && (
                <div className="mt-3">
                  <h6 className="text-sm font-semibold text-gray-800 mb-2">
                    Selected Proof Files
                  </h6>
                  <ul className="space-y-2">
                    {proofFiles.map((fileObj, index) => (
                      <li
                        key={index}
                        className="flex items-center justify-between bg-gray-100 p-2 rounded text-xs shadow-sm"
                      >
                        <div className="flex-1">
                          <p className="font-medium text-gray-900 truncate">
                            {fileObj.file.name}
                          </p>
                          {fileObj.isUploading && (
                            <div className="relative pt-1">
                              <div className="bg-gray-200 rounded-full h-1.5 overflow-hidden">
                                <div
                                  className="bg-indigo-600 h-1.5 rounded-full transition-all duration-300"
                                  style={{ width: `${fileObj.progress}%` }}
                                />
                              </div>
                              <span className="text-gray-600 mt-1 block">
                                {fileObj.progress}% Uploading
                              </span>
                            </div>
                          )}
                          {fileObj.error && (
                            <p className="text-red-600 mt-1">
                              Error: {fileObj.error}
                            </p>
                          )}
                          {fileObj.uploadId && (
                            <p className="text-green-600 mt-1">
                              Uploaded (ID: {fileObj.uploadId})
                            </p>
                          )}
                        </div>
                        <div className="flex gap-1">
                          {fileObj.signed_url && (
                            <button
                              onClick={() => handleViewProofFile(fileObj)}
                              className="text-indigo-600 hover:text-indigo-800"
                            >
                              <FontAwesomeIcon icon={faEye} />
                              <FontAwesomeIcon icon={faEye} />
                            </button>
                          )}
                          <button
                            onClick={() => handleRemoveProofFile(fileObj)}
                            className="text-red-500 hover:text-red-700"
                            disabled={fileObj.isUploading}
                          >
                            <FontAwesomeIcon icon={faTimes} />
                          </button>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              {errors.proof_guarantee_upload && (
                <p className="text-xs text-red-500">
                  {errors.proof_guarantee_upload.message}
                </p>
              )}
            </motion.section>
          )}
        </AnimatePresence>
        {/* Final SOA Files Upload Section - similar, shows loaded files */}
        <motion.section
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="space-y-3 rounded-lg border border-purple-200 bg-purple-50 p-4 shadow-sm"
        >
          <h5 className="flex items-center space-x-2 text-xs font-semibold text-gray-900">
            <FontAwesomeIcon icon={faFileInvoice} className="text-purple-500" />
            <span>Attach Final SOA Files *</span>
          </h5>
          {/* File Upload Area - unchanged */}
          <div className="mt-3">
            <div
              className={`relative border-2 border-dashed rounded-lg p-4 text-center transition-all duration-300 ${
                isDraggingSoa
                  ? "border-indigo-500 bg-indigo-50 scale-105"
                  : "border-gray-300 bg-gray-50"
              }`}
              onDragOver={handleDragOverSoa}
              onDragLeave={handleDragLeaveSoa}
              onDrop={handleDropSoa}
            >
              <FontAwesomeIcon
                icon={faUpload}
                className="text-2xl text-indigo-500 mb-2"
              />
              <p className="text-gray-700 text-sm">
                Drag and drop PDF or image files here or{" "}
                <button
                  type="button"
                  onClick={handleChooseSoaFile}
                  className="text-indigo-600 font-medium hover:text-indigo-800 transition-colors text-xs"
                >
                  choose files
                </button>
              </p>
              <p className="text-xs text-gray-500 mt-1">
                Supported formats: .pdf, .jpg, .jpeg, .png (Allowed size:{" "}
                {uploadFileSizeLimitLabel} per file, up to {maxUploadLimit} files)
              </p>
              <input
                type="file"
                ref={soaFileInputRef}
                multiple
                accept=".pdf,.jpg,.jpeg,.png"
                onChange={(e) => handleSoaFileChange(e.target.files)}
                className="hidden"
              />
            </div>
          </div>
          {/* File List - now shows loaded files too */}
          {soaFiles.length > 0 && (
            <div className="mt-3">
              <h6 className="text-sm font-semibold text-gray-800 mb-2">
                Selected SOA Files
              </h6>
              <ul className="space-y-2">
                {soaFiles.map((fileObj, index) => (
                  <li
                    key={index}
                    className="flex items-center justify-between bg-gray-100 p-2 rounded text-xs shadow-sm"
                  >
                    <div className="flex-1">
                      <p className="font-medium text-gray-900 truncate">
                        {fileObj.file.name}
                      </p>
                      {fileObj.isUploading && (
                        <div className="relative pt-1">
                          <div className="bg-gray-200 rounded-full h-1.5 overflow-hidden">
                            <div
                              className="bg-indigo-600 h-1.5 rounded-full transition-all duration-300"
                              style={{ width: `${fileObj.progress}%` }}
                            />
                          </div>
                          <span className="text-gray-600 mt-1 block">
                            {fileObj.progress}% Uploading
                          </span>
                        </div>
                      )}
                      {fileObj.error && (
                        <p className="text-red-600 mt-1">
                          Error: {fileObj.error}
                        </p>
                      )}
                      {fileObj.uploadId && (
                        <p className="text-green-600 mt-1">
                          Uploaded (ID: {fileObj.uploadId})
                        </p>
                      )}
                    </div>
                    <div className="flex gap-1">
                      {fileObj.signed_url && (
                        <button
                          onClick={() => handleViewSoaFile(fileObj)}
                          className="text-indigo-600 hover:text-indigo-800"
                        >
                          <FontAwesomeIcon icon={faEye} />
                        </button>
                      )}
                      <button
                        onClick={() => handleRemoveSoaFile(fileObj)}
                        className="text-red-500 hover:text-red-700"
                        disabled={fileObj.isUploading}
                      >
                        <FontAwesomeIcon icon={faTimes} />
                      </button>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          )}
          {errors.soa_fileupload && (
            <p className="text-xs text-red-500">
              {errors.soa_fileupload.message}
            </p>
          )}
        </motion.section>
      </div>

      <ToastContainer />
    </motion.div>
  );
};
export default ConfinementInformationTab;
